(function ($, _, root, undefined) {
    'use strict';

    var assetId = 'uc209-productview';

    // Main product controller
    function productViewController($viewContainer, productViewModel) {
        var model = productViewModel;
        var pubsub = root.PubSub;
        var utils = new util();
        var say = new notificator(pubsub, utils);
        var variantProcessorsMap = {};
        var flags = null;
        var cart = null;
        var rating = null;
        var gallery = null;
        var priceTotals = null;
        var packageComponents = null;
        var groupingProduct = null;

        if (model.discountID) {
            console.info(model.title + ' - Discount ID: ' + model.discountID);
        }

        return {
            init: function () {
                // Not optimal, but the call stack is complex with many dependecies and not async.
                // These causes problems if do load variant-selector-provider only in the initVariantsProcessor
                // Will be solved when ProductView.js will be rewritten in modules and web-components
                importShim('/components/archive/product/variant-selector-provider/variant-selector-provider.js').then(async function(){
                    var quantityDiscounts = new quantityDiscountsProcessor($viewContainer, model);
                    var externalTracking = new externalTrackingProcessor();

                    priceTotals = new priceTotalsProcessor($viewContainer, utils, model);
                    priceTotals.init();

                    if (model.isProductWithVariants) {
                        var preselectedVariants = _getPreselectedVariantsFromQueryString();
                        const options = {
                            $productContainer: $viewContainer,
                            productModel: model,
                            priceTotals: priceTotals,
                            quantityDiscountsProcessorInstance: quantityDiscounts,
                            externalTrackingProcessorInstance: externalTracking,
                            preselectedVariants: preselectedVariants,
                            enableHistoryState: true,
                            metadata: model.metadata,
                            say: say,
                            pubsub: pubsub,
                            utils: utils,
                        };
                        initVariantsProcessor(options, variantProcessorsMap);
                    }

                    if (!model.isVariantProductOfProductWithVariants) {
                        quantityDiscounts.renderQuantityDiscounts();
                    }

                    if (model.packageComponentProducts) {
                        _.each(model.packageComponentProducts, function (packageComponent) {
                            if (packageComponent.isMainProductOfProductWithVariants) {
                                const $componentProductContainer = $viewContainer.find('.js-component-products-list .js-component-product[data-uniqueid="' + packageComponent.uniqueId + '"]');
                                packageComponent.variantRelImageMatchRegExp = model.variantRelImageMatchRegExp;
                                const options = {
                                    $productContainer: $componentProductContainer,
                                    productModel: packageComponent,
                                    priceTotals: priceTotals,
                                    metadata: model.metadata,
                                    say: say,
                                    pubsub: pubsub,
                                    utils: utils,
                                };
                                initVariantsProcessor(options, variantProcessorsMap);
                            }
                        });
                        packageComponents = new packageComponentProcessor($viewContainer, model, utils);
                    }

                    if (model.groupingComponents) {
                        groupingProduct = new groupingProductProcessor($viewContainer, model, utils, say, pubsub, priceTotals, variantProcessorsMap);
                        await groupingProduct.init();
                    } else if (model.showCalculateShippingTool) {
                        $viewContainer.find('shipping-details').on('click', function (evt) {
                            const quantity = $viewContainer.find('.js-quantity').val() || 1;
                            document.querySelector('shipping-details').shippingProducts = [{productId: model.productId, quantity: quantity}];
                        });
                    }

                    if (model.additionalProducts) {
                        _.each(model.additionalProducts, function (additionalProduct) {
                            if (additionalProduct.isProductWithVariants) {
                                const $additionalProductContainer = $viewContainer.find('.js-additional-product[data-uniqueid="' + additionalProduct.uniqueId + '"]');
                                additionalProduct.variantRelImageMatchRegExp = model.variantRelImageMatchRegExp;
                                const options = {
                                    $productContainer: $additionalProductContainer,
                                    productModel: additionalProduct,
                                    priceTotals: priceTotals,
                                    metadata: model.metadata,
                                    say: say,
                                    pubsub: pubsub,
                                    utils: utils,
                                };
                                initVariantsProcessor(options, variantProcessorsMap);
                            }
                        });
                    }

                    // Initial calculation - some quantities may be pre-set
                    priceTotals.updatePriceTotals();

                    cart = new cartProcessor($viewContainer, model, say, pubsub, variantProcessorsMap, utils, priceTotals);
                    cart.init();

                    flags = new flagsProcessor($viewContainer, model);
                    flags.init();

                    rating = new ratingProcessor($viewContainer, model, pubsub);
                    rating.init();

                    var shoppingListHandler = new shoppingListProcessor($viewContainer, model, say, utils, variantProcessorsMap);
                    shoppingListHandler.init();

                    if (model.isPrintEnabled) {
                        var printHanlder = new printProcessor($viewContainer, model);
                        printHanlder.init();
                    }

                    var pdfHadnler = new pdfProcessor($viewContainer, model);
                    pdfHadnler.init();

                    if (model.isPriceRequestEnabled) {
                        var priceRequestHandler = priceRequestProcessor($viewContainer);
                        priceRequestHandler.init();
                    }

                    gallery = new galleryProcessor($viewContainer, model);
                    gallery.init();

                    externalTracking.reportProductsView($viewContainer, model);

                    var enableRelationExtensionDataProcessing = model.isProductRelationsExtensionEnabled && model.isProductWithVariants && model.additionalProducts && model.additionalProducts.length;
                    if (enableRelationExtensionDataProcessing) {
                        var relExtDataProcessor = new relationExtensionDataProcessor($viewContainer, model, variantProcessorsMap, priceTotals, pubsub);
                        relExtDataProcessor.init();
                    }

                    const similarProductsSelect = $viewContainer.find('select.js-similar-products-selector');
                    if (similarProductsSelect.length) {
                        similarProductsSelect.on('change', (e) => window.location = e.target.selectedOptions[0].dataset.url);
                    }

                    if (model.showWarehouseStockInfo) {
                        const warehouseStocks = $viewContainer.find('stock-info-list').get(0);
                        if (warehouseStocks) {
                            warehouseStocks.setData(model.warehouseStocks);
                        }
                    }

                    setStockStatusTooltip($viewContainer, model, utils);
                });
            }
        };

        function _getPreselectedVariantsFromQueryString() {
            var result = {}, queryString = location.search.slice(1), re = /sel(?:\:|%3a){1}([^&=]+)=([^&]*)/gi, match;

            while ((match = re.exec(queryString))) {
                var paramKey = decodeURIComponent(match[1]).toLowerCase();
                var paramValue = decodeURIComponent(match[2].replace(/\+/g, ' ')).toLowerCase();
                result[paramKey] = paramValue;
            }

            return result;
        }
    }

    root.productViewController = productViewController;

    $(function () {
        if (root.umwAssets && root.umwAssets[assetId]) {
            root.umwAssets[assetId].forEach(function (ctx) {
                if (ctx) {
                    var mainPanelId = ctx.uniqueId;
                    var $mainPanel = $(`#${mainPanelId}`);

                    if ($mainPanel.length === 1) {
                        var controller = new productViewController($mainPanel, ctx);
                        controller.init();
                    } else if ($mainPanel.length === 0) {
                        console.warn(assetId + ': product view main panel element was not found by id#' + mainPanelId);
                    } else {
                        console.warn(assetId + ': found >1 product view main panel elements with id#' + mainPanelId);
                    }
                }
            });
        }
    });

    // Notifications processor
    function notificator(pubsub, utils) {
        function _notify(message, notificationType, timeout) {
            if (typeof message === 'object' && message !== null) {
                message = utils.extractErrorMessageFromResponse(message);
            }

            if (pubsub) {
                message = message.replace(/\n/g, "<br />");
                pubsub.publish('notification.' + notificationType, { text: message, timeout: timeout, maxVisible: 3});
            } else {
                var notificationTypeMap = {
                    'error': 'error',
                    'alert': 'log',
                    'success': 'log',
                    'warning': 'warn'
                };

                root.console[notificationTypeMap[notificationType]].apply(this, [message]);
            }
        }

        return {
            warning: function (message, timeout) {
                _notify(message, 'warning', timeout || false);
            },
            error: function (message, timeout) {
                _notify(message, 'error', timeout || false);
            },
            success: function (message, timeout) {
                _notify(message, 'success', timeout || 30000);
            }
        };
    }

    // Variants processor
    function variantsProcessor($productContainer, product, metadata, preselectedVariants, say, pubsub, priceTotalsController, quantityDiscounts, externalTracking, utils, enableHistoryState) {
        var $container = $productContainer;
        var $declaredVariantSelectors = utils.$getProductContainerElements($container, '.js-variant-selector');

        var variantControllers = {};
        var isVariantProductShown = false;
        var suppressVariantProductDetailsLoading = false;

        var variantsState = { controlId: product.uniqueId, selectedVariantProd: null };
        var suppressVariantChangedEvent = false;

        var currentlyUnavailableVariantsMap = {};

        function _onVariantSelectionChanged(changedVariantType, newVariantValue) {
            var changedVariantController = _getVariantControllerById(changedVariantType.id);
            var prevVariantValue = changedVariantController.selectedValue;
            changedVariantController.selectedValue = newVariantValue || 0;

            var selectedVariantValues = _getSelectedVariants();
            var selectedVariantProduct = _getSelectedVariantProduct(selectedVariantValues);

            if (!suppressVariantProductDetailsLoading) {
                if (selectedVariantProduct) {
                    const selectedVariant = changedVariantType.variants.find(x => x.id === newVariantValue);
                    _loadVariantProductDetails(selectedVariantProduct, selectedVariant);
                } else if (isVariantProductShown) {
                    // De-selection, or unavailable dimensions combination - load main product and show
                    _loadVariantProductDetails();
                }
            }

            if (quantityDiscounts) {
                quantityDiscounts.renderQuantityDiscounts(selectedVariantValues);
            }

            pubsub.publish('variantprocessor.variant.changed', [newVariantValue, prevVariantValue, changedVariantController]);
        }

        function _filterUnavailableVariants(newVariantValue) {
            var selectedVariantValues = [];
            Object.values(variantControllers).forEach(variantController => {
                if (variantController.selectedValue > 0) {
                    selectedVariantValues.push(variantController.selectedValue);
                }
            });

            if (newVariantValue) {
                selectedVariantValues = [newVariantValue];
            } else if (newVariantValue == 0) {
                currentlyUnavailableVariantsMap = {};
            }

            const isAnyVariantSelected = selectedVariantValues.length > 0;
            // set unavailable first
            product.variantProducts.forEach(variantProduct => {
                var isProductForCurrentSelection = selectedVariantValues.every(selectedVariantOption => variantProduct.variants.find(x => x === selectedVariantOption));
                if (!isAnyVariantSelected || isProductForCurrentSelection) {
                    variantProduct.variants.forEach(variantId => {
                        currentlyUnavailableVariantsMap[variantId] = { message: variantProduct.availabilityMessage, disabled: variantProduct.disableSelection, exists: variantProduct.exists };
                    });
                }
            });
            // set available for selected variant values
            product.variantProducts.forEach(variantProduct => {
                var isProductForCurrentSelection = selectedVariantValues.every(selectedVariantOption => variantProduct.variants.find(x => x === selectedVariantOption));
                if ((!isAnyVariantSelected || isProductForCurrentSelection) && (variantProduct.isAvailable || product.isPriceRequestEnabled && variantProduct.exists)) {
                    variantProduct.variants.forEach(variantId => {
                        delete currentlyUnavailableVariantsMap[variantId];
                    });
                }
            });

            _.each(variantControllers, function (variantController) {
                var preselectSingleAvailable = (_.isEmpty(preselectedVariants) || !preselectedVariants[variantController.variantType.name.toLowerCase()]) && variantController.variantType.variants.length === 1;
                variantController.selector.filterVariants(currentlyUnavailableVariantsMap, preselectSingleAvailable);
            });
        }

        function _processVariants() {
            var variantTypeToProductInfoMap = {};

            var selectedVariantTypes = [];
            var selectedVariantOptions = [];
            _.each(variantControllers, variantController => {
                if (variantController.selectedValue > 0) {
                    selectedVariantTypes.push(variantController.variantType.id);
                    selectedVariantOptions.push(variantController.selectedValue);
                }
            });

            const isAnyVariantSelected = selectedVariantOptions.length > 0;

            product.variantProducts.forEach(variantProduct => {
                var isProductForCurrentSelection = selectedVariantOptions.every(selectedVariantOption => variantProduct.variants.find(x => x === selectedVariantOption));
                if (!isAnyVariantSelected || isProductForCurrentSelection) {
                    variantProduct.variants.forEach(variantId => {
                        if (variantProduct.discountInfo) {
                            variantTypeToProductInfoMap[variantId] = {
                                discountInfo: variantProduct.discountInfo
                            };
                        }
                    });
                }
            });

            _.each(variantControllers, function (variantController) {
                variantController.selector.processVariants(variantTypeToProductInfoMap);
            });
        }

        function _loadVariantProductDetails(variantProduct, selectedVariant) {
            var beforeLoadEvent = $.Event('variantsprocessor:beforeloadvariantproduct');
            $container.trigger(beforeLoadEvent, [variantProduct, selectedVariant]);

            if (beforeLoadEvent.isDefaultPrevented()) {
                isVariantProductShown = !!variantProduct;
                return;
            }

            $.blockUI({ message: '' });

            var selectedVariants = variantProduct ? variantProduct.variants : [];
            var $sellPriceFormatted = utils.$getProductContainerElements($container, '.js-sellprice-formatted');
            const isSellPriceVisible = product.showPrice && $sellPriceFormatted.length > 0 && $sellPriceFormatted.is(':visible');

            $.ajax({
                url: root.R + 'handlers/public/productdata.ashx',
                type: 'GET',
                data: {
                    a: 'GetDimDetails',
                    ItemID: product.itemId,
                    Dim1: selectedVariants[0] !== undefined ? selectedVariants[0] : 0,
                    Dim2: selectedVariants[1] !== undefined ? selectedVariants[1] : 0,
                    Dim3: selectedVariants[2] !== undefined ? selectedVariants[2] : 0,
                    CanHandleDisallowedBuyDims: true,
                    ImageWidth: product.previewImageWidth,
                    ImgMod: product.previewImageMode,
                    InclVat: product.sellPrice ? product.sellPrice.inclVat : null,
                    includeWarehouseStock: product.showWarehouseStockInfo,
                    priceVisible: isSellPriceVisible
                }
            })
                .always($.unblockUI)
                .done(function (variantProductDetails) {
                    _updateViewProductWithNewData(variantProductDetails);

                    if (enableHistoryState === true) {
                        _updateHistory(variantProductDetails);
                    }

                    pubsub.publish('variantprocessor.variantproduct.updated', { variantProductDetails, product });
                })
                .fail(function (errorResponse) {
                    say.error(errorResponse);
                });

            function _updateViewProductWithNewData(newData) {
                // Note: all raw prices, discount percent, price2, price3, ean, measurements, weight and all other dimension-specific possible values are not supported at the moment (20.09.2018)
                product.isMainProductOfProductWithVariants = newData.IsMainProd;
                product.isVariantProductOfProductWithVariants = isVariantProductShown = !newData.IsMainProd;
                var $priceFromText = utils.$getProductContainerElements($container, '.js-price-fromtext');
                if ($priceFromText.length > 0) {
                    $priceFromText.toggle(product.isMainProductOfProductWithVariants);
                }

                product.productId = newData.ProductID;
                $container.data('productid', product.productId);

                product.prodno = newData.ProdNo;
                utils.$getProductContainerElements($container, '.js-product-number').text(product.prodno);

                product.title = newData.FullTitle;
                utils.$getProductContainerElements($container, '.js-product-title').text(product.title);

                if (externalTracking) {
                    externalTracking.reportProductDetailsView(product.productId);
                }

                if (newData.ImageURL) {
                    product.mainImage = {
                        id: newData.ImageID,
                        title: newData.ImageText,
                        description: newData.ImageText,
                        actualWidth: newData.ImageActualWidth,
                        actualHeight: newData.ImageActualHeight,
                        thumbnailUrl: newData.ImageRelURL,
                        previewUrl: newData.ImageURL,
                        fullSizeUrl: newData.ImageLBURL,
                        displayWidth: newData.ImagePreviewDisplayWidth,
                        displayHeight: newData.ImagePreviewDisplayHeight
                    };

                    var $mainImage = utils.$getProductContainerElements($container, '.js-product-mainimage');
                    if ($mainImage.length > 0) {
                        $mainImage.attr('src', product.mainImage.previewUrl);
                        $mainImage.attr('alt', product.mainImage.title);

                        $mainImage.attr('data-imageid', product.mainImage.id);
                        $mainImage.data('imageid', product.mainImage.id);

                        if (product.mainImage.displayWidth && product.mainImage.displayHeight) {
                            $mainImage.attr('width', product.mainImage.displayWidth);
                            $mainImage.attr('height', product.mainImage.displayHeight);
                        }

                        if (product.galleryId) {
                            var $mainImageGalleryLink = $mainImage.closest('[data-fancybox="' + product.galleryId + '"]');
                            if ($mainImageGalleryLink.length === 1) {
                                $mainImageGalleryLink.attr('href', product.mainImage.fullSizeUrl);

                                $mainImageGalleryLink.attr('data-caption', product.mainImage.description);
                                $mainImageGalleryLink.data('caption', product.mainImage.description);

                                $mainImageGalleryLink.attr('data-width', product.mainImage.actualWidth);
                                $mainImageGalleryLink.data('width', product.mainImage.actualWidth);

                                $mainImageGalleryLink.attr('data-height', product.mainImage.actualHeight);
                                $mainImageGalleryLink.data('height', product.mainImage.actualHeight);
                            }
                        }
                    }
                }

                product.stockText = newData.StockText;
                product.stockColor = newData.StockColor;

                var oldStockCssClass = product.stockCssClass;
                product.stockCssClass = newData.StockCssClass;

                var $stockText = utils.$getProductContainerElements($container, '.js-stock-text');

                if ($container.hasClass(oldStockCssClass)) $container.removeClass(oldStockCssClass);
                if ($stockText.hasClass(oldStockCssClass)) $stockText.removeClass(oldStockCssClass);

                if (product.stockCssClass) {
                    $container.addClass(product.stockCssClass);
                    $stockText.addClass(product.stockCssClass);
                }

                var hasDiscountCssClass = "has-discount";
                if (newData.HasDiscount && !$container.hasClass(hasDiscountCssClass)) {
                    if(product.dontShowDiscountForMainProduct && product.isMainProductOfProductWithVariants){
                        $container.removeClass(hasDiscountCssClass);
                    } else {
                        $container.addClass(hasDiscountCssClass);
                    }
                } else if (!newData.HasDiscount && $container.hasClass(hasDiscountCssClass)) {
                    $container.removeClass(hasDiscountCssClass);
                } else if (newData.HasDiscount && $container.hasClass(hasDiscountCssClass) && product.dontShowDiscountForMainProduct && product.isMainProductOfProductWithVariants) {
                    $container.removeClass(hasDiscountCssClass);
                }

                var $vippsHurtigkasseButton = utils.$getProductContainerElements($container, '.js-vipps-hurtigkasse-button');

                const $addProductToCartButton = utils.$getProductContainerElements($container, '.js-batch-buy-button, .js-buy-button');

                if (newData.AllowBuy) {
                    $vippsHurtigkasseButton.show();

                    if($addProductToCartButton.prop("disabled") === true) {
                        $addProductToCartButton.prop("disabled", false);
                    }
                } else {
                    $vippsHurtigkasseButton.hide();

                    if ($addProductToCartButton.prop("disabled") === false) {
                        $addProductToCartButton.prop("disabled", true);
                    }
                }

                var stockDataColorVariable = $stockText.data('style-color-variable');

                if ($stockText.length > 0) {
                    $stockText.text(product.stockText);
                    if ($stockText.data('update-style-color') !== false) { // for backwards compatibility
                        $stockText.css('color', product.stockColor || 'inherit');
                    }
                    if (stockDataColorVariable) {
                        if(product.stockColor && product.stockColor.length > 0){
                            $stockText[0].style.setProperty(stockDataColorVariable, product.stockColor);
                        } else {
                            $stockText.removeAttr('style');
                        }
                    }
                }

                if (product.sellPrice) {
                    product.sellPrice.formatted = newData.Price;
                    product.sellPrice.raw = newData.PriceRaw; // not available in the incoming data set

                    var $sellPriceFormatted = utils.$getProductContainerElements($container, '.js-sellprice-formatted');
                    if ($sellPriceFormatted.length > 0) {
                        if(product.dontShowDiscountForMainProduct && product.isMainProductOfProductWithVariants) {
                            $sellPriceFormatted.text(product.beforePrice.formatted);
                        } else {
                            $sellPriceFormatted.text(product.sellPrice.formatted);
                        }
                    }
                }

                if (product.sellPriceWithVAT) {
                    product.sellPriceWithVAT.formatted = newData.PriceInclVat;
                    delete product.sellPriceWithVAT.raw; // not available in the incoming data set

                    var $sellPriceWithVatFormatted = utils.$getProductContainerElements($container, '.js-sellprice-withvat-formatted');
                    if ($sellPriceWithVatFormatted.length > 0) {
                        $sellPriceWithVatFormatted.text(product.sellPriceWithVAT.formatted);
                    }
                }

                if (product.sellPriceWithoutVAT) {
                    product.sellPriceWithoutVAT.formatted = newData.PriceExclVat;
                    delete product.sellPriceWithoutVAT.raw; // not available in the incoming data set

                    var $sellPriceWithoutVatFormatted = utils.$getProductContainerElements($container, '.js-sellprice-withoutvat-formatted');
                    if ($sellPriceWithoutVatFormatted.length > 0) {
                        $sellPriceWithoutVatFormatted.text(product.sellPriceWithoutVAT.formatted);
                    }
                }

                if (product.beforePrice) {
                    product.beforePrice.formatted = newData.OriginalPrice;
                    delete product.beforePrice.raw; // not available in the incoming data set

                    var $beforePriceFormatted = utils.$getProductContainerElements($container, '.js-beforeprice-formatted');
                    if ($beforePriceFormatted.length > 0) {
                        var $beforePriceElements = utils.$getProductContainerElements($container, '.js-beforeprice-value, .js-beforeprice-label').add($beforePriceFormatted);
                        if (newData.HasDiscount) {
                            if(product.dontShowDiscountForMainProduct && product.isMainProductOfProductWithVariants){
                                $beforePriceElements.hide();
                                $beforePriceElements.parent().addClass('no-beforeprice-value');
                            } else {
                                $beforePriceFormatted.text(product.beforePrice.formatted);
                                $beforePriceElements.show();
                                $beforePriceElements.parent().removeClass('no-beforeprice-value');
                            }
                        } else {
                            $beforePriceElements.hide();
                            $beforePriceElements.parent().addClass('no-beforeprice-value');
                        }
                    }
                }

                if (product.discountPrice) {
                    product.discountPrice.formatted = newData.Discount;
                    delete product.discountPrice.raw; // not available in the incoming data

                    var $discountPriceFormatted = utils.$getProductContainerElements($container, '.js-discountprice-formatted');
                    if ($discountPriceFormatted.length > 0) {
                        var $discountPriceElements = utils.$getProductContainerElements($container, '.js-discountprice-value, .js-discountprice-label').add($discountPriceFormatted);

                        if (newData.HasDiscount && product.discountPrice.formatted) {
                            $discountPriceFormatted.text(product.discountPrice.formatted);

                            $discountPriceElements.show();
                        } else {
                            $discountPriceElements.hide();
                        }
                    }
                }

                if (product.discountPercent) {
                    product.discountPercent.formatted = newData.DiscountPercent;
                    delete product.discountPercent.raw; // not available in the incoming data

                    var $discountPercentFormatted = utils.$getProductContainerElements($container, '.js-discountpercent-formatted');
                    if ($discountPercentFormatted.length > 0) {
                        var $discountPercentElements = utils.$getProductContainerElements($container, '.js-discountpercent-value, .js-discountpercent-label').add($discountPercentFormatted);

                        if (newData.HasDiscount && product.discountPercent.formatted) {
                            if(product.dontShowDiscountForMainProduct && product.isMainProductOfProductWithVariants){
                                $discountPercentElements.hide();
                            } else {
                                $discountPercentFormatted.text('-' + product.discountPercent.formatted + '%');
                                $discountPercentElements.show();
                            }
                        } else {
                            $discountPercentElements.hide();
                        }
                    }
                }

                if (product.discountToDate) {
                    product.discountToDate.formatted = newData.DiscountToDate;
                    delete product.discountToDate.raw; // not available in the incoming data

                    var $discountToDateFormatted = utils.$getProductContainerElements($container, '.js-discounttodate-formatted');
                    if ($discountToDateFormatted.length > 0) {
                        var $discountToDateElements = utils.$getProductContainerElements($container, '.js-discounttodate-value, .js-discounttodate-label, .js-discounttodate').add($discountToDateFormatted);

                        if (newData.HasDiscount && product.discountToDate.formatted) {
                            $discountToDateFormatted.text(product.discountToDate.formatted);

                            $discountToDateElements.show();
                        } else {
                            $discountToDateElements.hide();
                        }
                    }
                }

                if (newData.DiscountID) {
                    console.info(newData.FullTitle + ' - Discount ID: ' + newData.DiscountID);
                }

                if (product.comparablePrice) {
                    product.comparablePrice.formatted = newData.ComparablePrice;
                    delete product.comparablePrice.raw; // not available in the incoming data set

                    var $comparablePriceFormatted = utils.$getProductContainerElements($container, '.js-comparableprice-formatted');
                    if ($comparablePriceFormatted.length > 0) {
                        $comparablePriceFormatted.text(product.comparablePrice.formatted);
                    }
                }

                if (product.factorPrice) {
                    product.factorPrice.formatted = newData.FactorPrice;
                    delete product.factorPrice.raw; // not available in the incoming data set

                    var $factorPriceFormatted = utils.$getProductContainerElements($container, '.js-factor-price-formatted');
                    if ($factorPriceFormatted.length > 0) {
                        $factorPriceFormatted.text(product.factorPrice.formatted);
                    }
                }

                if (product.productInFactorPrice) {
                    product.productInFactorPrice.formatted = newData.ProductInFactorPrice;
                    delete product.productInFactorPrice.raw; // not available in the incoming data set

                    var $productInFactorPriceFormatted = utils.$getProductContainerElements($container, '.js-product-in-factor-price-formatted');
                    if ($productInFactorPriceFormatted.length > 0) {
                        $productInFactorPriceFormatted.text(product.productInFactorPrice.formatted);
                    }
                }

                var $replacementProductContainer = utils.$getProductContainerElements($container, '.js-replacement-product-container');
                if ($replacementProductContainer.length > 0) {
                    if (newData.ReplacementProductInfo) {
                        $replacementProductContainer.empty().html(newData.ReplacementProductInfo).show();
                    } else {
                        $replacementProductContainer.empty().hide();
                    }
                }

                priceTotalsController.updatePriceTotals();

                // Supplier order info
                setStockStatusTooltip($container, newData, utils);

                // Warehouse stock infos
                const warehouseStocks = utils.$getProductContainerElements($container, 'stock-info-list').get(0);
                if (warehouseStocks) {
                    warehouseStocks.setData(newData.warehouseStocks);
                }

                // QR code
                const qrCode = utils.$getProductContainerElements($container, 'product-qr-print-button').get(0);
                if (qrCode) {
                    qrCode.productIds = [newData.ProductID];
                }
            }

            function _updateHistory(variantProductDetails) {
                if (root.history && typeof (root.history.pushState) !== 'undefined') {
                    var urlParts = location.href.split('#', 2);
                    var resultUrl = variantProductDetails.IsMainProd ? $.removeQueryStringParam(urlParts[0], 'dpid') : $.setQueryStringParam(urlParts[0], 'dpid', variantProductDetails.ProductID);
                    resultUrl = urlParts.length === 1 ? resultUrl : resultUrl + '#' + urlParts[1];

                    if (resultUrl !== location.href) {
                        variantsState.selectedVariantProd = variantProduct;
                        root.history.pushState(variantsState, null, resultUrl);
                    }
                }
            }
        }

        function _selectVariantControllersValues(variants, isFromHistory) {
            _.each(variantControllers, function (x) {
                var preselectVariantTypeValue = _.find(x.variantType.variants, function (y) { return _.indexOf(variants, y.id) !== -1; });
                if (preselectVariantTypeValue && preselectVariantTypeValue.id > 0) {
                    x.selectedValue = preselectVariantTypeValue.id;
                    x.selector.setSelected(preselectVariantTypeValue.id, isFromHistory);
                } else {
                    say.error('Variant type "' + x.variantType.name + '" has no corresponding variant value for the shown variant product. Please check variants configuration for the product.');
                }
            });
        }

        function _onHistoryPopState(evt) {
            var state = evt.originalEvent.state;
            if (state && state.controlId === product.uniqueId) {
                variantsState = state;
                suppressVariantChangedEvent = true;

                if (state.selectedVariantProd) {
                    _selectVariantControllersValues(state.selectedVariantProd.variants, true);
                } else {
                    _.each(variantControllers, function (x) {
                        x.selectedValue = 0;
                        x.selector.setSelected(0, true);
                    });
                }

                suppressVariantChangedEvent = false;
                _loadVariantProductDetails(variantsState.selectedVariantProd);
                _filterUnavailableVariants();
            }
        }

        function _getVariantControllerById(variantTypeId) {
            return variantControllers['vt' + variantTypeId];
        }

        function _getVariantControllerByTypeName(variantTypeName) {
            var foundController = _.find(variantControllers, function (controller) {
                return utils.caseInsensetiveEquals(controller.variantType.name, variantTypeName);
            });

            return foundController;
        }

        function _selectVariantByName(variantTypeName, variantValueName) {
            if (variantTypeName && variantValueName) {
                var variantController = _getVariantControllerByTypeName(variantTypeName);
                if (variantController) {
                    variantController.selector.setSelectedByName(variantValueName);
                }
            }
        }

        function _selectVariantByProductId(variantProductId) {
            const selectedVariants = _getPreselectedVariants(variantProductId);
            _.each(selectedVariants, function (preselectedVariantValue, preselectedVariantType) {
                _selectVariantByName(preselectedVariantType, preselectedVariantValue);
            });
        }

        function _getSelectedVariantProduct(selectedVariantValues) {
            var selectedVariantProduct = null;
            var isSelectionComplete = _.every(selectedVariantValues, function (x) { return x > 0; });
            if (isSelectionComplete) {
                var variantProductsForSelection = _getProductsForCurrentSelection();

                if (variantProductsForSelection.length === 0) {
                    say.warning(metadata['noAvailableVariantProducts']);
                } else if (variantProductsForSelection.length === 1) {
                    selectedVariantProduct = variantProductsForSelection[0];
                } else if (variantProductsForSelection.length > 1) {
                    say.warning(metadata['invalidVariantsConfiguration'] + ' ' + metadata['multipleAvailableVariantProducts']);
                }
            }
            return selectedVariantProduct;

            function _getProductsForCurrentSelection() {
                var availableProducts = _.filter(product.variantProducts, function (x) {
                    return _.every(selectedVariantValues, function (y) { return _.indexOf(x.variants, y) !== -1; });
                });

                return availableProducts;
            }
        }

        function _getSelectedVariants() {
            return _.map(variantControllers, function (currentController) {
                return currentController.selectedValue || 0;
            });
        }

        function _getNotSelectedVariants() {
            return _.filter(variantControllers, function (x) { return !(x.selectedValue > 0); });
        }

        function _isVariantsSelectionValid(prodTitle) {
            var notSelectedVariants = _getNotSelectedVariants();
            var isSelectionValid = notSelectedVariants.length === 0;

            if (!isSelectionValid) {
                var notSelectedVariantNames;
                _.each(notSelectedVariants, function (x, idx) {
                    var name = '<strong>' + x.variantType.name + '</strong>';
                    if (idx === 0) {
                        notSelectedVariantNames = name;
                    } else if (idx === notSelectedVariants.length - 1) {
                        notSelectedVariantNames += (' ' + metadata['and'] + ' ' + name);
                    } else {
                        notSelectedVariantNames += (', ' + name);
                    }
                });

                say.warning(prodTitle + ' - ' + metadata['pleaseSelect'] + ' ' + notSelectedVariantNames, 10000);
            }

            return isSelectionValid;
        }

        function _getPreselectedVariants(variantProductId) {
            if (variantProductId) {
                var variantProduct = _.find(product.variantProducts, function (x) { return x.productId === variantProductId });
                if (variantProduct) {
                    const result = {};
                    _.each(product.variantTypes, function (x) {
                        var selectVariantValue = _.find(x.variants, function (y) { return _.indexOf(variantProduct.variants, y.id) !== -1; });
                        if (selectVariantValue && selectVariantValue.id > 0) {
                            result[x.name] = selectVariantValue.name;
                        }
                    });
                    return result;
                }
            }
            return null;
        }

        return {
            init: async function () {
                const showPricesInclVat = product.sellPrice ? product.sellPrice.inclVat : null;
                var promises = [];

                $declaredVariantSelectors.each(function () {
                    const $selector = $(this);
                    const viewBuilderName = $selector.data('viewbuilder') || '';
                    const variantTypeId = $selector.data('varianttypeid');
                    const loadAdditionalInfoDataAttrValue = $selector.data('loadadditionalinfo');
                    let loadAdditionalInfo = null;
                    if (typeof (loadAdditionalInfoDataAttrValue) == 'boolean') {
                        loadAdditionalInfo = loadAdditionalInfoDataAttrValue;
                    } else if (typeof (loadAdditionalInfoDataAttrValue) == 'string') {
                        loadAdditionalInfo = loadAdditionalInfoDataAttrValue === 'true';
                    } else {
                        loadAdditionalInfo = product.groupingComponents ? false : true;
                    }

                    promises.push(root.createVariantSelector(viewBuilderName, this, product, variantTypeId, new Map(Object.entries(metadata)), showPricesInclVat, loadAdditionalInfo));

                    const variantType = _.find(product.variantTypes, function (x) { return x.id === variantTypeId; });
                    const variantController = {
                        variantType: variantType,
                        selectedValue: 0,
                        selector: null,
                        $elem: $selector
                    };

                    const variantControllerKey = 'vt' + variantTypeId;
                    variantControllers[variantControllerKey] = variantController;
                });

                await Promise.all(promises).then(function (selectors) {
                    _.each(selectors, function (selector) {
                        if (typeof selector !== 'undefined') {
                            selector.render();

                            const variantTypeId = selector.variantType.id;
                            const variantControllerKey = 'vt' + variantTypeId;
                            variantControllers[variantControllerKey].selector = selector;
                        }
                    });

                    variantControllers = Object.keys(variantControllers)
                        .filter(key => variantControllers[key].selector !== null)
                        .reduce((newObj, key) => {
                            newObj[key] = variantControllers[key];
                            return newObj;
                        }, {});

                    $declaredVariantSelectors.on('variantselector:changed', function (evt, changedVariantType, newVariantValue) {
                        if (!suppressVariantChangedEvent) {
                            _onVariantSelectionChanged(changedVariantType, newVariantValue);

                            // If the single available variant is changing itself, then it is nothing to filter.
                            if (_.keys(variantControllers).length > 1) {
                                _filterUnavailableVariants(newVariantValue);
                            }
                        }
                    });

                    _filterUnavailableVariants(); // Initial filtering of variants that have no available products at all
                    _processVariants();

                    var initialVariantProduct = _.find(product.variantProducts, function (x) { return x.productId === product.productId; });
                    if (initialVariantProduct) {
                        variantsState.selectedVariantProd = initialVariantProduct;
                        // Pre-select if variant product is shown initially
                        suppressVariantProductDetailsLoading = true; // Suppress variant product loading while preselecting variants for already loaded variant products

                        _selectVariantControllersValues(initialVariantProduct.variants, false);

                        isVariantProductShown = true;

                        suppressVariantProductDetailsLoading = false; // Restore variant product loading on variants change
                    } else if (!_.isEmpty(preselectedVariants)) {
                        _.each(preselectedVariants, function (preselectedVariantValue, preselectedVariantType) { _selectVariantByName(preselectedVariantType, preselectedVariantValue); });
                    }

                    if (enableHistoryState === true) {
                        if (root.history && typeof (root.history.replaceState) !== 'undefined') {
                            root.history.replaceState(variantsState, null, null);
                        }

                        $(root).on('popstate', _onHistoryPopState);
                    }
                }).catch((error) => { console.error(error); });
            },
            $selectors: $declaredVariantSelectors,
            getSelectedVariantProduct: function () {
                var selectedVariantValues = _getSelectedVariants();
                return _getSelectedVariantProduct(selectedVariantValues);
            },
            getNotSelectedVariants: _getNotSelectedVariants,
            selectVariantByName: _selectVariantByName,
            selectVariantByProductId: _selectVariantByProductId,
            isVariantsSelectionValid: _isVariantsSelectionValid,
        };
    }

    async function initVariantsProcessor(options, variantProcessorsMap) {
        var processor = new variantsProcessor(options.$productContainer, options.productModel, options.metadata, options.preselectedVariants, options.say, options.pubsub, options.priceTotals,
            options.quantityDiscountsProcessorInstance, options.externalTrackingProcessorInstance, options.utils, options.enableHistoryState);

        variantProcessorsMap[options.productModel.uniqueId] = processor;
        await processor.init();
    }

    function setStockStatusTooltip($container, model, utils) {
        const stockStatusTooltip = utils.$getProductContainerElements($container, 'cms-tooltip').get(0);
        if (stockStatusTooltip) {
            let supplierOrderInfo = stockStatusTooltip.shadowRoot.querySelector('supplier-order-info');
            let stockTextTooltip = stockStatusTooltip.shadowRoot.querySelector('.js-stock-text-tooltip');
            let $stockTextInfoIcon = utils.$getProductContainerElements($container, '.js-stock-text-info');
            let showStockStatusTooltip = model.stockStatusTooltipInfo?.length > 0 || (supplierOrderInfo && (model.inSupplierOrder || model.InSupplierOrder));
            stockStatusTooltip.visible = showStockStatusTooltip;

            if (!showStockStatusTooltip) {
                $stockTextInfoIcon.hide();
                return;
            }

            let tooltipText = model.stockStatusTooltipInfo.replace(/\n/g, "<br />");
            stockTextTooltip.innerHTML = tooltipText;

            if (model.inSupplierOrder || model.InSupplierOrder) {
                supplierOrderInfo.update(model.ProductID).then(() => {
                    if (stockTextTooltip && supplierOrderInfo?.hasSupplierOrderInfo && model.stockStatusTooltipInfo?.length > 0) {
                        stockTextTooltip.innerHTML = tooltipText;
                    }
                });
            }

            $stockTextInfoIcon.show();
        }
    }

    // Cart processor
    function cartProcessor($view, model, say, pubsub, variantProcessorsMap, utils, priceTotals) {
        var estore = root.PublicEStore;
        var productsInCartMap = {};
        var productsToCustomFieldIdsForOrderMap = {};
        var vippsDialogModule = null;
        var vippsDialog = null;
        var shouldResetOnDecisionCallback = false;
        function _addToCart(addToCartContracts, $handler) {
            $view.addClass('buying');
            $.when(estore.addToCart(addToCartContracts))
                .always(function () { $view.removeClass('buying'); })
                .done(function (dataContract) {
                    pubsub.publish('frontend.productview.product.isbought');
                    $handler.addClass('is-bought');
                    setTimeout(function () {
                        $handler.removeClass('is-bought');
                    }, 2000);

                    if (dataContract.status.toLowerCase() !== 'ok') {
                        if (dataContract.result.items && dataContract.result.items.length) {
                            _.each(dataContract.result.items, function (resultItem) {
                                var itemStatus = resultItem.status.toLowerCase();
                                var productModel = _getFirstProductModelByProductId(resultItem.productID);
                                var statusMessage = [productModel.title, resultItem.message].join(' - ');
                                switch (itemStatus) {
                                    case 'error':
                                        say.error(statusMessage);
                                        break;
                                    case 'warning':
                                        say.warning(statusMessage);
                                        break;
                                }
                            });
                        } else {
                            _showPublicEStoreError(dataContract);
                        }
                    } else {
                        if (model.tempOrderLineId > 0) {
                            root.location.href = model.cartUrl;
                        }
                    }
                })
                .fail(_showPublicEStoreError);
        }

        function _showPublicEStoreError(pefContract) {
            var exractedMessage;

            if (typeof pefContract === 'string') {
                exractedMessage = pefContract;
            } else {
                exractedMessage = pefContract.result && pefContract.result.items[0] ? pefContract.result.items[0].message : pefContract.message;
            }

            say.error(exractedMessage);
        }

        function _getCustomFieldsContract($container, customFieldIdsForOrder) {
            var customFields = {};
            var $customFieldControls = utils.$getProductContainerElements($container, '.js-custom-field');

            $customFieldControls.each(function () {
                var $customFieldControl = $(this);
                var customFieldId = $customFieldControl.data('customfieldid');
                var customFieldValue = $customFieldControl.is(':checkbox') ? $customFieldControl.is(':checked').toString() : $customFieldControl.val();

                if (_.indexOf(customFieldIdsForOrder, customFieldId) !== -1 && typeof customFieldValue !== 'undefined') {
                    customFields[customFieldId] = customFieldValue;
                }
            });

            return customFields;
        }

        function _isFormValid($container, prodTitle) {
            var isFormValid = true;

            // Trigger jquery form validation
            var validator = $container.validate({ ignore: [] });
            var $requiredFields = utils.$getProductContainerElements($container, '[data-rule-required]');
            $requiredFields.each(function () {
                var $requiredField = $(this);
                isFormValid &= validator.element($requiredField);
            });

            if (!isFormValid) {
                say.warning(prodTitle + ' - ' + model.metadata['formIsInvalid']);
            }

            return isFormValid;
        }

        function _isQuantityValid(minQuantity, quantity, prodTitle) {

            var isQuantityValid = true;

            if (minQuantity && quantity < minQuantity) {
                say.warning(prodTitle + ' - ' + model.metadata['minQuantityIs'] + ' ' + minQuantity);
                isQuantityValid = false;
            }

            return isQuantityValid;
        }

        function _toggleCartIndicator(animate) {
            // Works for the general product only, not for additionals.
            var variantProductIds = model.variantProducts != null ? $.map(model.variantProducts, function (variant) { return variant.productId; }) : null;
            var displayedProductId = model.productId;
            var isMainProductDisplayed = model.isMainProductOfProductWithVariants;

            // Find if displayed product is in cart and collect its quantity-in-cart value.
            // If the displayed product is main product of a product with variants then sum up quantity-in-carts of all its variant products.
            var numberQuantityInCart = _.reduce(productsInCartMap, function (memo, qtyInCart, productId) {
                productId = parseInt(productId);

                var includeQtyInCart = productId === displayedProductId || isMainProductDisplayed && _.indexOf(variantProductIds, productId) > -1;

                return memo + (includeQtyInCart ? qtyInCart : 0);
            }, 0);

            var isProductInCart = numberQuantityInCart > 0;

            var $cartQuantity = utils.$getProductContainerElements($view, '.js-cart-quantity');
            var $cartIndicator = utils.$getProductContainerElements($view, '.js-cart-indicator');

            $cartQuantity.text(numberQuantityInCart);
            $cartQuantity.toggle(isProductInCart);

            if (isProductInCart) {
                if ($cartIndicator.length > 0) {
                    $cartIndicator.show();
                    if (animate) {
                        $view.effect('transfer', { to: $cartIndicator }, 500, function () { $cartIndicator.effect('bounce', null, 500); });
                    }
                }
            } else {
                $cartIndicator.hide();
            }
        }

        function _addToCartHandler(topic, dataContract) {
            var currentProduct = _findCurrentProductInTheContract(dataContract);
            if (currentProduct) {
                productsInCartMap[currentProduct.productID] = currentProduct.totalQuantityInTempOrderLine;
                _toggleCartIndicator(true);
            }
        }

        function _removeFromCartHandler(topic, dataContract) {
            _.each(dataContract.result.items, function (x) {
                if (x.status.toLowerCase() === 'ok') {
                    var deletedProductId = x.productID;
                    delete productsInCartMap[deletedProductId];

                    var isVariantProductOfDisplayedMainProductDeleted = model.isMainProductOfProductWithVariants && _.some(model.variantProducts, function (variantProd) {
                        return variantProd.productId === deletedProductId;
                    });
                    if (deletedProductId === model.productId || isVariantProductOfDisplayedMainProductDeleted) {
                        _toggleCartIndicator();
                    }
                }
            });
        }

        function _emptyCartHandler(topic, dataContract) {
            if (dataContract.status.toLowerCase() === 'ok') {
                productsInCartMap = {};

                _toggleCartIndicator();
            }
        }

        function _getCartInfoHandler(topic, dataContract) {
            var cartInfo = dataContract.result.detailedCartInfo;

            if (dataContract.status.toLowerCase() === 'ok') {
                productsInCartMap = {};

                if (cartInfo.products && cartInfo.products.length > 0) {
                    _.each(cartInfo.products, function (x) {
                        productsInCartMap[x.productID] = (productsInCartMap[x.productID] || 0) + x.quantity;
                    });
                }

                _toggleCartIndicator();
            }
        }

        function _findCurrentProductInTheContract(contract) {
            var currentProduct = _.find(contract.result.items, function (x) {
                return x && x.status.toLowerCase() === 'ok' && (x.productID === model.productId || model.additionalProducts && model.additionalProducts.filter(function (value) { return value.productId === x.productID; }).length > 0);
            });

            return currentProduct;
        }

        function _getProductModelByUniqueId(uniqueId) {
            var productModel = null;

            if (uniqueId) {
                if (model.uniqueId === uniqueId) {
                    // General product ᕦ(ò_óˇ)ᕤ
                    productModel = model;
                } else {
                    // Try find the product in additionals
                    if (!productModel && model.additionalProducts) {
                        productModel = model.additionalProducts.find(function (additionalProduct) { return additionalProduct.uniqueId === uniqueId; });
                    }

                    if (!productModel && model.packageComponentProducts) {
                        productModel = model.packageComponentProducts.find(function (componentProduct) { return componentProduct.uniqueId === uniqueId; });
                    }

                    if (!productModel && model.groupingComponents) {
                        model.groupingComponents.every(groupingComponent => {
                            if (productModel) {
                                return false;
                            }
                            productModel = groupingComponent.componentProducts.find(groupingComponentProduct => groupingComponentProduct.uniqueId === uniqueId);
                            return true;
                        });
                    }
                }
            }

            if (!productModel) {
                console.warn(`Product model was not found by unique id ${uniqueId}`);
            }
            return productModel;
        }

        function _getFirstProductModelByProductId(productId) {
            var productModel = null;

            productId = parseInt(productId);

            if (productId) {
                if (model.productId === productId) {
                    // General product ᕦ(ò_óˇ)ᕤ
                    productModel = model;
                }

                if (!productModel && model.additionalProducts) {
                    // Try find the product in additionals
                    productModel = model.additionalProducts.find(function (additionalProduct) { return additionalProduct.productId === productId; });
                }

                if (!productModel && model.packageComponentProducts) {
                    productModel = model.packageComponentProducts.find(function (componentProduct) { return componentProduct.productId === productId; });
                }

                if (!productModel && model.groupingComponents) {
                    model.groupingComponents.every(groupingComponent => {
                        if (productModel) {
                            return false;
                        }
                        productModel = groupingComponent.componentProducts.find(groupingComponentProduct => groupingComponentProduct.productId === productId);
                        return true;
                    });
                }
            }

            if (!productModel) {
                console.warn(`First product model was not found by product id ${productId}`);
            }
            return productModel;
        }

        function _getAddToCartContractFromContainer($productContainer, buyType, parentProductId, parentProductUniqueId, packageQuantity) {
            var addToCartContracts = null;

            const productUniqueId = $productContainer.data('uniqueid');
            const productKey = $productContainer.data('uniquekey');
            const productType = $productContainer.data('producttype') || 'Product';
            var productModel = _getProductModelByUniqueId(productUniqueId);

            var customFieldIdsForOrder = productsToCustomFieldIdsForOrderMap[productModel.productId] ? productsToCustomFieldIdsForOrderMap[productModel.productId] : [];
            if (!customFieldIdsForOrder.length) {
                _.each(productModel.customFields, function (x) {
                    if ((x.displayType === 'editable' || x.displayType === 'hidden') && x.includeInOrder) {
                        customFieldIdsForOrder.push(x.id);
                    }
                });
                productsToCustomFieldIdsForOrderMap[productModel.productId] = customFieldIdsForOrder;
            }

            var quantity = 0;
            var fraction = 0;

            switch ((buyType || '').toLowerCase()) {
                case 'fraction':
                    fraction = utils.tryParseNumberOrDefault($productContainer.find('.js-fraction').val());
                    break;
                case 'factor':
                    quantity = $productContainer.find('.js-quantity').val() || 1;
                    break;
                case 'package':
                    var packageSize = productModel.packageSize || 1;
                    var packageQty = $productContainer.find('.js-package-quantity').val() || 1;
                    quantity = packageQty * packageSize;
                    break;
                case 'package_component':
                    quantity = productModel.initialQuantity.raw * packageQuantity;
                    break;
                case 'grouping_product_component':
                    quantity = utils.tryParseNumberOrDefault($productContainer.find('.js-quantity').val(), 1) * packageQuantity;
                    break;
                default:
                    quantity = utils.tryParseNumberOrDefault($productContainer.find('.js-quantity').val(), 1);
                    fraction = utils.tryParseNumberOrDefault($productContainer.find('.js-fraction').val());
                    break;
            }

            var minQuantity = productModel.minQuantity ? productModel.minQuantity.raw : undefined;

            if (_isFormValid($productContainer, productModel.title) && _isQuantityValid(minQuantity, quantity, productModel.title)) {
                var productVariantsProcessor = variantProcessorsMap[productModel.uniqueId];
                if (!productVariantsProcessor || productVariantsProcessor.isVariantsSelectionValid(productModel.title)) {

                    var packageComponents = null, groupingComponentProducts = null, hasError = false;

                    if (productModel.packageComponentProducts) {
                        packageComponents = [];
                        var $packageComponentsContainer = utils.$getProductContainerElements($productContainer, '.js-component-products-list');
                        _.each(productModel.packageComponentProducts, function (packageComponent) {
                            var $componentProductContainer = $packageComponentsContainer.find('.js-component-product[data-uniqueid="' + packageComponent.uniqueId + '"]');
                            var componentContracts = _getAddToCartContractFromContainer($componentProductContainer, 'package_component', productModel.productId, productModel.uniqueId, quantity);
                            if (componentContracts) {
                                packageComponents = packageComponents.concat(componentContracts);
                            } else {
                                hasError = true;
                            }
                        });
                    }

                    if (productModel.groupingComponents) {
                        groupingComponentProducts = [];
                        var $groupingProductContainer = utils.$getProductContainerElements($productContainer, '.js-grouping-product-container');
                        productModel.groupingComponents.forEach(groupingComponent => {
                            groupingComponent.componentProducts.forEach(groupingComponentProduct => {
                                const $groupingProductProductContainer = $groupingProductContainer.find('.js-grouping-product[data-uniqueid="' + groupingComponentProduct.uniqueId + '"]');
                                let isSelected = $groupingProductProductContainer.data('isselected');
                                isSelected = typeof (isSelected) === 'boolean' ? isSelected : false;
                                if (isSelected) {
                                    var groupingProductContracts = _getAddToCartContractFromContainer($groupingProductProductContainer, 'grouping_product_component', productModel.productId, productModel.uniqueId, quantity);
                                    if (groupingProductContracts) {
                                        groupingComponentProducts = groupingComponentProducts.concat(groupingProductContracts);
                                    } else {
                                        hasError = true;
                                    }
                                }
                            });
                        });
                    }

                    if (!hasError) {
                        var addToCartContract = {
                            productKey: productKey,
                            productId: productModel.productId,
                            productType: productType,
                            parentProductId: parentProductId,
                            quantity: quantity,
                            fraction: fraction,
                            customFields: _getCustomFieldsContract($productContainer, customFieldIdsForOrder),
                            tempOrderLineId: productModel.tempOrderLineId,
                            imageId: productModel.mainImage ? productModel.mainImage.id : undefined,
                            componentOfPackageProductID: buyType === 'package_component' ? parentProductUniqueId : null,
                        };

                        addToCartContracts = [addToCartContract];

                        if (packageComponents) {
                            addToCartContract.packageProductID = productModel.uniqueId;
                            addToCartContracts = addToCartContracts.concat(packageComponents);
                        }

                        if (groupingComponentProducts) {
                            addToCartContracts = addToCartContracts.concat(groupingComponentProducts);
                        }
                    }
                }
            }

            return addToCartContracts;
        }

        function _processVippsHurtigkasseCheckout(vippsHurtigkasseComponent) {
            $.when(_prepareCartForCheckout()).then(function (proceedToCheckout) {
                if (proceedToCheckout) {
                    vippsHurtigkasseComponent.startCheckout(true);
                }
            }, _showPublicEStoreError);

            function _prepareCartForCheckout() {
                const deferred = $.Deferred();

                $.when(estore.getTempOrderLines(null, true)).then(function (tempOrderLinesResult) {

                    if (tempOrderLinesResult.status.toLowerCase() === 'ok') {
                        const areOtherProductsInCart = tempOrderLinesResult.result.items.length > 0;
                        if (areOtherProductsInCart) {

                            var $productContainer = utils.$getProductContainerFor(vippsHurtigkasseComponent);
                            var addToCartContract = _getAddToCartContractFromContainer($productContainer);

                            if (addToCartContract) {
                                const lines = tempOrderLinesResult && tempOrderLinesResult.result ? tempOrderLinesResult.result.items : null;

                                const currentGroupPrices = priceTotals.getCurrentTotals();
                                const mainPriceGroup = currentGroupPrices && currentGroupPrices.length ? currentGroupPrices.find((g) => !g.group) : null;

                                let productPrice = null;

                                if (mainPriceGroup) {
                                    productPrice = mainPriceGroup.priceRaw;
                                } else {
                                    const quantity = utils.tryParseNumberOrDefault($view.find('.js-quantity').val(), 1);
                                    productPrice = model.sellPrice.raw * quantity;
                                }

                                const currentCartSum = lines ? lines.map((i) => i.linePrice).reduce((a, c) => a + c, 0) : 0;
                                const currentCartQuantity = lines ? lines.map((i) => i.quantity).reduce((a, c) => a + c, 0) : 0;

                                const dialogData = {
                                    cartLink: model.cartUrl,
                                    cartCount: currentCartQuantity,
                                    cartSum: currentCartSum + productPrice,
                                    productPrice: productPrice
                                };

                                if (vippsDialog) {
                                    if (shouldResetOnDecisionCallback) {
                                        vippsDialog.setOnDecision(_onDecision);
                                        shouldResetOnDecisionCallback = false;
                                    }
                                    vippsDialog.show(dialogData);
                                } else {
                                    vippsDialogModule.then((module) => {
                                        vippsDialog = new module.VippsBuyProductDialog(_onDecision);

                                        $view.append(vippsDialog);

                                        vippsDialog.show(dialogData);
                                    });
                                }
                            }
                        } else {
                            _addToCartAndResolveDeferred();
                        }
                    } else {
                        deferred.reject(dataContract);
                    }
                }, deferred.reject);

                return deferred.promise();

                function _onDecision(decision) {
                    if (decision === 'only-product') {
                        $.when(estore.emptyCart()).then(function () {
                            _addToCartAndResolveDeferred();
                        }, deferred.reject);
                    } else if (decision === 'whole-cart') {
                        _addToCartAndResolveDeferred();
                    } else {
                        console.warn('Unsupported decision from Vipps dialog: ' + decision);
                    }

                }

                function _addToCartAndResolveDeferred() {
                    var $productContainer = utils.$getProductContainerFor(vippsHurtigkasseComponent);
                    var addToCartContract = _getAddToCartContractFromContainer($productContainer);

                    if (addToCartContract) {
                        $.when(estore.addToCart(addToCartContract, null, true)).then(function (addToCartResult) {
                            if (addToCartResult.status.toLowerCase() === 'ok') {
                                deferred.resolve(true);
                            } else {
                                deferred.reject(addToCartResult);
                            }
                        }, deferred.reject);
                    } else {
                        deferred.reject();
                    }
                }
            }
        }

        return {
            init: function () {
                estore.subscribe('estore.callback.shopcart.addtocart', _addToCartHandler);
                estore.subscribe('estore.callback.shopcart.removefromcart', _removeFromCartHandler);
                estore.subscribe('estore.callback.shopcart.emptycart', _emptyCartHandler);
                estore.subscribe('estore.callback.shopcart.getdetailedcartinfo', _getCartInfoHandler);

                $.when(estore.getDetailedCartInfo());

                var mainProductVariants = variantProcessorsMap[model.uniqueId];
                if (mainProductVariants) {
                    pubsub.subscribe('variantprocessor.variantproduct.updated', function () { _toggleCartIndicator(); });
                }

                $view.find('.js-buy-button,.js-buy-additional-product-button').on('click', function (evt) {
                    evt.preventDefault();

                    var $buyButton = $(this);

                    var $productContainer = utils.$getProductContainerFor(this);
                    var buyType = $buyButton.data('buy-type');

                    var addToCartContract = _getAddToCartContractFromContainer($productContainer, buyType);
                    if (addToCartContract) {
                        _addToCart(addToCartContract, $buyButton);
                    }
                });

                $view.find('.js-batch-buy-button').on('click', function (evt) {
                    evt.preventDefault();

                    // Collect all products with quantity > 0
                    var addToCartContracts = [];
                    var allContractsAreValid = true;
                    $view.find('.js-quantity').each(function () {
                        var $quantity = $(this);
                        var quantity = utils.tryParseNumberOrDefault($quantity.val());

                        var contracts = null;
                        if (quantity > 0) {
                            var $prodContainer = utils.$getProductContainerFor($quantity);
                            contracts = _getAddToCartContractFromContainer($prodContainer);
                            if (contracts) {
                                addToCartContracts = addToCartContracts.concat(contracts);
                            } else {
                                allContractsAreValid = false;
                            }
                        }
                    });

                    if (addToCartContracts.length) {
                        if (allContractsAreValid) {
                            _addToCart(addToCartContracts, $(this));
                        }
                    } else if (allContractsAreValid) {
                        say.warning(model.metadata['nothingToBuy']);
                    }
                });

                var vippsHurtigkasse = $view.find('vipps-hurtigkasse');

                if (vippsHurtigkasse && vippsHurtigkasse.length) {
                    importShim('/components/checkout/vipps/cms-vipps-hurtigkasse.js');
                    vippsDialogModule = importShim('/components/checkout/vipps/vipps-buy-product-dialog.js');

                    vippsHurtigkasse.on('onbeforestart', function (evt) {
                        evt.preventDefault();

                        _processVippsHurtigkasseCheckout(evt.target);
                    });

                    window.addEventListener("pagehide", (evt) => {
                        if (evt.persisted) {
                            jQuery.unblockUI();
                            shouldResetOnDecisionCallback = true;
                        }
                    })
                }

                utils.initQuantityModifyButtons($view, '.js-quantity-modify-btn'); // deprecated from product view v2.7.0, left for backwards compatibility
                utils.initQuantityModifyButtons2($view, '.js-plus-minus-container');
            }
        };
    }

    // Flags processor
    function flagsProcessor($view, model) {
        var flagsHandlerUrl = root.R + 'startup/api/v1/acrhive/flags/connections/visible';
        var itemId = model.itemId;

        function _getFlags() {
            $.get(flagsHandlerUrl, { itemIds: [itemId], archiveType: 20, })
                .done(function (data) {
                    if (!_.isEmpty(data)) {
                        var flags = data[itemId];

                        var $flagsTarget = $view.find('.js-flags-target');
                        _.each(flags, function (flagDetails) {
                            var $flag = $('<span />',
                                {
                                    'class': 'flag flag-' + flagDetails.FlagID,
                                    text: flagDetails.Name,
                                    data: flagDetails
                                });

                            $flag.appendTo($flagsTarget);

                            var replaceEmptyString = flagDetails.Name.replace(/\s+/g, "-").toLowerCase();
                            $('.uc-product-view').addClass(replaceEmptyString + ' flag-' + flagDetails.FlagID + '-' + replaceEmptyString);
                        });
                    }
                });
        }

        return {
            init: function () {
                _getFlags();
            }
        }
    }

    // Rating processor
    function ratingProcessor($view, model, pubsub) {
        var itemId = model.itemId;

        function _updateRating() {
            $.ajax({
                url: root.R + 'handlers/public/productdata.ashx?a=getrating&itemid=' + itemId,
                type: 'GET'
            })
                .done(function (ratingData) {
                    // Update data model
                    model.rating = ratingData.rating;
                    model.commentsCount = ratingData.commentsCount;
                    model.ratingsCount = ratingData.ratingsCount;
                    model.hasUserPostedReview = ratingData.hasUserPostedReview;

                    // Update UI
                    _buildRatingView();

                    $view.find('.js-add-review').toggle(!model.hasUserPostedReview);

                    $view.find('.js-rating-comments-count').text(ratingData.commentsCount);
                    $view.find('.js-rating-ratings-count').text(ratingData.commentsCount);
                });
        }

        function _buildRatingView() {
            var ratingTemplate = '<% _.each(stars, function(star){ %><i class="c-rating__star<%= (star === "half" ? " c-rating__star_half" : star === "empty" ? " c-rating__star_empty" : "") %>" aria-hidden="true"></i><% }); %>';
            var ratingModel = { stars: _buildStars() };

            var $ratingHtml = _.template(ratingTemplate, ratingModel);

            $view.find('.js-rating-container').empty().append($ratingHtml);

            function _buildStars() {
                var starsCount = 5;
                var starredRatingValue = model.rating * starsCount;

                var stars = [];

                for (var wholeStar = 1; wholeStar <= starredRatingValue; wholeStar++) {
                    stars.push('whole');
                }

                var incompleteStarValue = starredRatingValue - stars.length;
                if (incompleteStarValue > 0) {
                    stars.push(incompleteStarValue > 0.5 ? 'whole' : 'half');
                }

                var emptyStars = starsCount - stars.length;
                for (var emptyStar = 0; emptyStar < emptyStars; emptyStar++) {
                    stars.push('empty');
                }

                return stars;
            }
        }

        return {
            init: function () {
                $(function () {
                    _buildRatingView();

                    pubsub.subscribe('reviewscontrol.reviewaction', function (topic, itemId) {
                        if (itemId === model.itemId) {
                            _updateRating();
                        }
                    });

                    $view.find('.js-add-review').click(function (evt) {
                        evt.preventDefault();

                        pubsub.publish('reviewscontrol.focus', model.itemId);
                    });
                });
            }
        }
    }

    // Print processor
    function printProcessor($view, model) {
        return {
            init: function () {
                $view.find('.js-print-button').on('click', function (evt) {
                    evt.preventDefault();

                    if (model.printPath) {
                        var printUrl = root.R + model.printPath + '?ItemID=' + model.itemId + '&ProductID=' + model.productId;
                        root.open(printUrl, 'remote', 'resizable=yes,status=0,menubar=0,scrollbars=1,left=0,top=0,width=780,height=950,location=0');
                    } else {
                        console.error('Print handler is not configured on the website');
                    }
                });
            }
        }
    }

    // PDF processor
    function pdfProcessor($view, model) {
        return {
            init: function () {
                $view.find('.js-downloadpdf-button').on('click', function (evt) {
                    evt.preventDefault();

                    var pdfUrl = root.R + 'RenderToPdf.aspx?ProductID=' + model.productId;
                    if (model.pdfTemplateId > 0) {
                        pdfUrl += '&TemplateID=' + model.pdfTemplateId;
                    }

                    root.open(pdfUrl, '_blank');
                });
            }
        }
    }

    // Gallery processor
    function galleryProcessor($view, model) {
        var fancyboxInstance;
        var fancyboxOptions = {
            selector: '[data-fancybox="' + model.galleryId + '"]',
            loop: true,
            hash: false
        };

        return {
            init: function () {
                fancyboxInstance = $view.fancybox(fancyboxOptions);
            }
        }
    }

    // Shopping list & wish list processor
    function shoppingListProcessor($view, model, say, utils, variantProcessorsMap) {
        function _isVariantsSelectionValid(productVariantsProcessor) {
            var isSelectionValid;

            if (typeof productVariantsProcessor !== 'undefined' && productVariantsProcessor !== null) {
                var notSelectedVariants = productVariantsProcessor.getNotSelectedVariants();
                isSelectionValid = notSelectedVariants.length === 0;

                if (!isSelectionValid) {
                    var notSelectedVariantNames;
                    _.each(notSelectedVariants, function (x, idx) {
                        var name = '<strong>' + x.variantType.name + '</strong>';
                        if (idx === 0) {
                            notSelectedVariantNames = name;
                        } else if (idx === notSelectedVariants.length - 1) {
                            notSelectedVariantNames += (' ' + model.metadata['and'] + ' ' + name);
                        } else {
                            notSelectedVariantNames += (', ' + name);
                        }
                    });

                    say.warning(model.metadata['pleaseSelect'] + ' ' + notSelectedVariantNames + ' ' + model.metadata['toAddToShoppingList']);
                }
            } else {
                isSelectionValid = true;
            }

            return isSelectionValid;
        }

        return {
            init: function () {
                $view.find('.js-add-to-shopping-list-btn').click(function (evt) {
                    evt.preventDefault();

                    var $productContainer = utils.$getProductContainerFor(this);
                    var productUniqueId = $productContainer.data('uniqueid');
                    var productVariantsProcessor = variantProcessorsMap[productUniqueId];

                    if (_isVariantsSelectionValid(productVariantsProcessor)) {
                        var addType = $(this).data('add-type');

                        var quantity = 0;
                        var fraction = 0;

                        switch ((addType || '').toLowerCase()) {
                            case 'fraction':
                                fraction = utils.tryParseNumberOrDefault($productContainer.find('.js-fraction').val());
                                break;
                            case 'factor':
                                quantity = $productContainer.find('.js-quantity').val() || 1;
                                break;
                            default:
                                quantity = utils.tryParseNumberOrDefault($productContainer.find('.js-quantity').val(), 1);
                                fraction = utils.tryParseNumberOrDefault($productContainer.find('.js-fraction').val());
                                break;
                        }

                        var contractForShoppingList = [
                            {
                                productId: model.productId,
                                imageId: model.mainImage.id,
                                quantity: quantity,
                                fraction: fraction,
                                customFields: model.customFields
                            }
                        ];
                        root.showAddToCollectionPopup(contractForShoppingList);
                    }
                });

                $view.find('.js-add-additional-product-to-shopping-list-btn').click(function (evt) {
                    evt.preventDefault();

                    var additionalProductId = $(this).data("additional-product-id");
                    var additionalProductModel = model.additionalProducts.filter(function (value) {
                        return value.productId === additionalProductId;
                    })[0];

                    var quantity = utils.tryParseNumberOrDefault($view.find(".js-additional-product-quantity[data-additional-product-id='" + additionalProductId + "']").val(), 1);
                    var fraction = utils.tryParseNumberOrDefault($view.find(".js-additional-product-fraction[data-additional-product-id='" + additionalProductId + "']").val());

                    var contractForShoppingList = [
                        {
                            productId: additionalProductModel.productId,
                            imageId: additionalProductModel.mainImage.id,
                            quantity: quantity,
                            fraction: fraction,
                        }
                    ];
                    root.showAddToCollectionPopup(contractForShoppingList);
                });

                $view.find('.js-add-to-wish-list-btn').click(function (evt) {
                    evt.preventDefault();
                    var $wishListControl = $(this);

                    var isAddToWishListAction = $wishListControl.hasClass('c-wish-list-btn_add');


                    if (model.isAvailableToBuy && !model.isMainProductOfProductWithVariants) {
                        root.updateWishList(model.productId, isAddToWishListAction ? 'add' : 'remove', wishListCallback);
                    }
                    else
                    {
                        var $productContainer = utils.$getProductContainerFor($wishListControl);
                        var productUniqueId = $productContainer.data('uniqueid');
                        var productVariantsProcessor = variantProcessorsMap[productUniqueId];
                        var notSelectedVariants = productVariantsProcessor.getNotSelectedVariants();
                        var notSelectedVariantNames;
                        _.each(notSelectedVariants, function (x, idx) {
                            var name = '<strong>' + x.variantType.name + '</strong>';
                            if (idx === 0) {
                                notSelectedVariantNames = name;
                            } else if (idx === notSelectedVariants.length - 1) {
                                notSelectedVariantNames += (' ' + model.metadata['and'] + ' ' + name);
                            } else {
                                notSelectedVariantNames += (', ' + name);
                            }
                        });

                        say.warning(model.metadata['pleaseSelect'] + ' ' + notSelectedVariantNames + ' ' + model.metadata['toAddToWishList']);
                    }

                    function wishListCallback(dataContract) {
                        if (dataContract.status.toLowerCase() === 'ok') {
                            _.each(dataContract.result.items,
                                function (prod) {
                                    if (prod.status.toLowerCase() === 'ok') {
                                        say.success(model.metadata['wishListUpdated']);

                                        $wishListControl.toggleClass('c-wish-list-btn_add', !isAddToWishListAction);
                                        $wishListControl.toggleClass('c-wish-list-btn_remove',
                                            isAddToWishListAction);
                                    } else {
                                        say.error(prod.message);
                                    }
                                });
                        } else {
                            say.error(dataContract.message);
                        }
                    }

                });
            }
        }
    }

    function quantityDiscountsProcessor($view, model) {
        var $quantityDiscountsContainer = $view.find('.js-quantity-discounts');
        var $quantityDiscountsInfo = $view.find('.js-quantity-discounts-info');

        function renderQuantityDiscounts(selectedVariants) {
            $.ajax({
                url: root.R + 'handlers/public/estoredata.ashx',
                type: 'GET',
                data: {
                    a: 'GetQuantityDiscounts',
                    itemId: model.itemId,
                    dim1: selectedVariants !== undefined && selectedVariants[0] !== undefined ? selectedVariants[0] : 0,
                    dim2: selectedVariants !== undefined && selectedVariants[1] !== undefined ? selectedVariants[1] : 0,
                    dim3: selectedVariants !== undefined && selectedVariants[2] !== undefined ? selectedVariants[2] : 0,
                    showPrice: model.quantityDiscountVisibility === 'Price',
                    format: 'html'
                }
            })
                .done(function (result) {
                    if (result && result.length > 0) {
                        $quantityDiscountsContainer.show();
                        $quantityDiscountsInfo.html(result);
                    } else {
                        $quantityDiscountsContainer.hide();
                    }
                })
                .fail(function () {
                    $quantityDiscountsContainer.hide();
                });
        }

        return {
            renderQuantityDiscounts: function (selectedVariants) {
                if ($quantityDiscountsContainer.length > 0) {
                    renderQuantityDiscounts(selectedVariants);
                }
            }
        }
    }

    function priceRequestProcessor($view) {
        return {
            init: function () {

                var $feedbackControlContainer = $('.js-feedback-control');
                var $feedbackControlContainer2 = $('.js-feedback-control2');
                var $priceRequestContainerBtn = $view.find('.js-price-request-btn');

                $feedbackControlContainer = $feedbackControlContainer2.length > 0 ? $feedbackControlContainer2 : $feedbackControlContainer;

                if ($feedbackControlContainer.length > 0) {
                    $priceRequestContainerBtn.on('click', function () {
                        $.fancybox.open({
                            parentEl: "form:first",
                            src: $feedbackControlContainer,
                            type: 'inline'
                        });
                    });
                }

            }
        }
    }

    function externalTrackingProcessor() {
        function _reportAdditionalProductsView($viewContainer, model) {
            var viewProductName = $.trim(model.title || document.title);

            var $additionalProductsContainer = $viewContainer.find('.js-additional-product-list');
            var $additionalProducts = $additionalProductsContainer.find('.js-additional-product');

            if ($additionalProducts.length > 0) {
                var listName = viewProductName + ' > ' + ($additionalProductsContainer.data('listname') || model.metadata['additionalProductsTab']);
                var additionalProductIdsWithLinks = $additionalProducts.map(function () {
                    var $prod = $(this);
                    var productId = $prod.data('productid');
                    var $links = $prod.find('.js-product-link');

                    return { productId: productId, $links: $links };
                }).get();

                root.reportProductListView(root.productListType.relatedProducts, listName, additionalProductIdsWithLinks);
            }
        }

        return {
            reportProductsView: function ($viewContainer, model) {
                root.reportProductDetailsView(model.productId);

                _reportAdditionalProductsView($viewContainer, model);
            },
            reportProductDetailsView: function (productId) {
                root.reportProductDetailsView(productId);
            },
        };
    }

    function relationExtensionDataProcessor($viewContainer, model, variantProcessorsMap, priceTotalsController, pubsub) {
        var relationExtData = null;

        var additionalProdMap = {}; // { relID1: { prodID1: { product1 }}}
        _.each(model.additionalProducts, function (prod) {
            if (prod.group && prod.group.groupType === 'Relation') {
                var relationId = prod.group.groupId;
                if (!additionalProdMap[relationId]) {
                    additionalProdMap[relationId] = {};
                }

                additionalProdMap[relationId][prod.productId] = prod;
            }
        });

        function _applyExtensionData(variantTypeName, variantValueName) {
            if (variantTypeName && variantValueName) {
                variantTypeName = variantTypeName.toLowerCase();
                variantValueName = variantValueName.toLowerCase();

                var extData = relationExtData[variantTypeName] ? relationExtData[variantTypeName][variantValueName] : null;
                if (extData) {
                    var isAnyQuantityAffected = false;

                    _.each(extData, function (extDataItem) {
                        var productId = extDataItem.productID;
                        if (productId === null) {
                            // Regular non-variant products do not store their productID in relation data. Therefore, need to resolve productID first.
                            productId = _getSingleProductIdByItemId(extDataItem.itemID);
                        }

                        var additionalProduct = _getAdditionalProduct(extDataItem.relationID, productId);
                        if (additionalProduct) {
                            var uniqueId = additionalProduct.uniqueId;
                            if (uniqueId) {
                                if (typeof (extDataItem.quantityInRelation) !== 'undefined') {
                                    $viewContainer.find('[data-uniqueid="' + uniqueId + '"] .js-quantity').val(extDataItem.quantityInRelation);
                                    isAnyQuantityAffected = true;
                                }

                                if (typeof (extDataItem.variants) !== 'undefined') {
                                    var variantsProc = variantProcessorsMap[uniqueId];
                                    if (variantsProc) {
                                        _.each(extDataItem.variants, function (variantValue, variantType) { variantsProc.selectVariantByName(variantType, variantValue); });
                                    }
                                }
                            }
                        }
                    });

                    if (isAnyQuantityAffected) {
                        priceTotalsController.updatePriceTotals();
                    }
                }
            }
        }

        function _getSelectedVariantTypeToValueNamePairs(product) {
            var namePairs = {};

            var variantProduct = _.find(product.variantProducts, function (x) { return x.productId === product.productId });
            if (variantProduct) {
                _.each(product.variantTypes, function (x) {
                    var selectVariantValue = _.find(x.variants, function (y) { return _.indexOf(variantProduct.variants, y.id) !== -1; });
                    if (selectVariantValue && selectVariantValue.id > 0) {
                        namePairs[x.name] = selectVariantValue.name;
                    }
                });
            }

            return namePairs;
        }

        function _renderExtensionDataGrids($extDataGridsContainer) {
            if (_.isEmpty(relationExtData) || _.isEmpty(additionalProdMap)) {
                $extDataGridsContainer.remove();
            } else {
                var extensionDataGridTemplateCompiled = _.template('<table><thead><tr><th></th><\% _.each(columns, function(column) { %><th><\%= column %></th><\% }); %></tr></thead><tbody><\% _.each(_.sortBy(rows, \'position\'), function(prod) { %><tr data-prod-uniqueid=\'<\%= prod.uniqueId %>\'><td><\%= prod.title %></td><\% _.each(columns, function(column) { %><td><\%= prod.extDataMap[column] ? prod.extDataMap[column].quantityInRelation : \'-\' %></td><\% }); %></tr><\% }); %></tbody></table>');

                // Render a separate grid for every general product's variant type with extension data.
                // Join extension data with existing additional products and ignore extension data for not available additional products.
                // Remember that there can be same products in different relations having their own relation extension data. So the key to the product should be productId + relationId.
                // Try follow the visible positions of the additional products shown.
                var visiblePositionMap = {};
                $viewContainer.find('.js-additional-product[data-uniqueid]').each(function (idx, elem) {
                    var uniqueId = $(elem).data('uniqueid');
                    if (uniqueId) {
                        visiblePositionMap[uniqueId] = idx;
                    }
                });

                _.each(relationExtData, function (variantTypeExtData, variantTypeName) {
                    var gridModel = { gridTitle: variantTypeName, columns: [], rows: {} };

                    _.each(variantTypeExtData, function (relProdExtDataArray, variantValueName) {
                        gridModel.columns.push(variantValueName);

                        _.each(relProdExtDataArray, function (relProdExtData) {
                            var rowId = relProdExtData.relationID + '_' + relProdExtData.productID;
                            // If the correpsonding product is found in additionals then add it to rows.
                            // If the product is not found then add null value so we do not check it once more.
                            if (typeof (gridModel.rows[rowId]) === 'undefined') {
                                var additionalProduct = _getAdditionalProduct(relProdExtData.relationID, relProdExtData.productID);
                                if (additionalProduct) {
                                    var visiblePosition = visiblePositionMap[additionalProduct.uniqueId];
                                    gridModel.rows[rowId] = {
                                        uniqueId: additionalProduct.uniqueId,
                                        group: additionalProduct.group.groupName,
                                        title: additionalProduct.title,
                                        position: visiblePosition > -1 ? visiblePosition : undefined,
                                        extDataMap: {}
                                    }
                                } else {
                                    gridModel.rows[rowId] = null;
                                }
                            }

                            if (gridModel.rows[rowId] !== null) {
                                gridModel.rows[rowId].extDataMap[variantValueName] = relProdExtData;
                            }
                        });
                    });

                    //filter rows with null value before template compilation
                    gridModel.rows = _.filter(gridModel.rows, function (row) {
                        return row !== null;
                    });
                    var gridHtml = extensionDataGridTemplateCompiled(gridModel);

                    $extDataGridsContainer.append(gridHtml);
                });
            }
        }

        function _getAdditionalProduct(relationId, productId) {
            return additionalProdMap[relationId] ? additionalProdMap[relationId][productId] : undefined;
        }

        function _getSingleProductIdByItemId(itemId) {
            var singleProduct = _.find(model.additionalProducts, function (additionalProd) { return !additionalProd.isProductWithVariants && additionalProd.itemId === itemId });

            return singleProduct ? singleProduct.productId : null;
        }

        function _oneTimeVariantProdUpdateHandler(topic, data) {
            pubsub.unsubscribe(_oneTimeVariantProdUpdateHandler);

            if (!data.variantProductDetails.IsMainProd) {
                var preselectedVariants = _getSelectedVariantTypeToValueNamePairs(model);
                _.each(preselectedVariants, function (valueName, typeName) { _applyExtensionData(typeName, valueName); });
            }
        }

        return {
            init: function () {
                var mainProductVariantsProcessor = variantProcessorsMap[model.uniqueId];

                if (mainProductVariantsProcessor) {
                    $.ajax({
                        url: root.R + 'api/archive/relation/foritem/' + model.itemId + '/variant/ext-data',
                        type: 'GET',
                        data: {
                            relationIds: _.keys(additionalProdMap)
                        }
                    })
                        .done(function (relationExtensionData) {
                            relationExtData = relationExtensionData;

                            if (relationExtData) {
                                if (model.isVariantProductOfProductWithVariants) {
                                    // Apply extension data immediately if variant product is shown initially
                                    var preselectedVariants = _getSelectedVariantTypeToValueNamePairs(model);
                                    _.each(preselectedVariants, function (valueName, typeName) { _applyExtensionData(typeName, valueName); });
                                } else {
                                    pubsub.subscribe('variantprocessor.variantproduct.updated', _oneTimeVariantProdUpdateHandler);
                                }

                                mainProductVariantsProcessor.$selectors.on('variantselector:changed', function (evt, changedVariantType, newVariantValue) {
                                    if (newVariantValue > 0) {
                                        var mainVariantValueDetails = _.find(changedVariantType.variants, function (variant) { return variant.id === newVariantValue; });

                                        _applyExtensionData(changedVariantType.name, mainVariantValueDetails.name);
                                    }
                                });
                            }

                            var $extDataGridsContainer = $viewContainer.find('.js-relation-extension-data-scheme');
                            if ($extDataGridsContainer.length > 0) {
                                _renderExtensionDataGrids($extDataGridsContainer);
                            }
                        })
                        .fail(function (errorResponse) {
                            console.error('[UMW]: Failed to get relation extension data', errorResponse);
                        });
                }
            }
        }
    }

    function priceTotalsProcessor($view, utils, model) {
        var additionalsGroup = 'additionals';
        var defaultGroup = 'default';
        var defaultEmptyText = '0';
        var valueLoadingText = '...';
        var updateTimer = null;
        var _currentTotals = null;

        var $priceTotalsElements;

        var cache = { empty: [] };

        function _buildCacheKey(products) {
            var cacheKey = products && products.length > 0 ? JSON.stringify(products) : 'empty';

            return cacheKey;
        }

        function _setResults(groupedTotals) {
            var totalsMap = {};
            _.each(groupedTotals, function (g) {
                g.hasDiscount = g.origPrice !== g.price;

                totalsMap[g.group || defaultGroup] = g;
            });

            $priceTotalsElements.each(function () {
                var $elem = $(this);
                var $elemContainer = $elem.closest('.js-price-totals-container');

                var group = $elem.data('price-totals-group') || defaultGroup;

                var totals = totalsMap[group] || {};
                var totalsType = $elem.data('price-totals') || 'sellprice';

                var totalsValue;
                switch (totalsType.toLowerCase()) {
                    case 'quantity':
                        totalsValue = totals.quantity || defaultEmptyText;
                        break;
                    case 'price':
                    case 'sellprice':
                        totalsValue = totals.price || defaultEmptyText;
                        break;
                    case 'originalprice':
                    case 'beforeprice':
                    case 'before':
                        totalsValue = totals.hasDiscount ? totals.origPrice : null;
                        break;
                    case 'discount':
                    case 'discountprice':
                        totalsValue = totals.hasDiscount ? totals.discPrice : null;
                        break;
                    default:
                        totalsValue = null;
                        break;
                }

                if (totalsValue !== null) {
                    $elem.text(totalsValue).show();
                    $elemContainer.show();
                } else {
                    $elem.hide();
                    $elemContainer.hide();
                }
            });

            const onTotalsUpdatedEvent = $.Event('priceTotalsProcessor:ontotalsupdated');
            $view.trigger(onTotalsUpdatedEvent, [groupedTotals]);
        }

        function _getProductsWithPositiveQuantities() {
            return $view.find('.js-quantity').map(function () {
                var $quantity = $(this);
                var quantity = utils.tryParseNumberOrDefault($quantity.val());

                var productContract = null;

                if (quantity > 0) {
                    const $productContainer = utils.$getProductContainerFor($quantity);
                    let isSelected = $productContainer.data('isselected');
                    isSelected = typeof (isSelected) === 'boolean' ? isSelected : true;

                    if (isSelected) {
                        const productkey = $productContainer.data('uniquekey');
                        const productId = $productContainer.data('productid');
                        let groupName = $quantity.data('price-totals-group') || $productContainer.data('price-totals-group');
                        if (!groupName) {
                            // Auto-detect group name
                            groupName = $productContainer.hasClass('js-additional-product') ? additionalsGroup : null;
                        }

                        productContract = {
                            productkey: productkey,
                            prodId: productId,
                            parentProductId: model.productId !== productId ? model.productId : 0,
                            itemId: model.itemId,
                            quantity: quantity,
                            productType: $productContainer.data('producttype') || 'Product',
                            group: groupName,
                        };
                    }
                }

                return productContract;
            }).get();
        };

        function _updatePriceTotals() {
            var products = _getProductsWithPositiveQuantities();

            if (model.showCalculateShippingTool && !model.groupingComponents) {
                let selectedProducts = products.map(p => ( { productId: p.prodId, quantity: p.quantity }));
                if (model.groupingComponents) {
                    selectedProducts.splice(selectedProducts.findIndex(p => p.productId == model.productId), 1);
                }

                let shippingDetails = document.querySelector('shipping-details');
                if(shippingDetails) {
                    shippingDetails.shippingProducts = selectedProducts;
                }
            }

            var cacheKey = _buildCacheKey(products);

            if (cache[cacheKey]) {
                _currentTotals = cache[cacheKey];
                _setResults(cache[cacheKey]);
            } else {
                $priceTotalsElements.text(valueLoadingText);

                $.ajax({
                    async: false,
                    url: root.R + 'handlers/public/productdata.ashx',
                    type: 'POST',
                    data: {
                        a: 'GetProductListQuantityPrice',
                        params: JSON.stringify({ products: products })
                    }
                })
                    .done(function (result) {
                        cache[cacheKey] = result;
                        _currentTotals = result;
                        _setResults(result);
                    })
                    .fail(function (errResp) {
                        var errorMessage = utils.extractErrorMessageFromResponse(errResp);
                        console.error('Failed to calculate price totals. ', errorMessage);
                    });
            }
        }

        return {
            init: function () {
                $priceTotalsElements = $view.find('[data-price-totals]');
                var isAnyElementFound = $priceTotalsElements.length > 0;

                if (isAnyElementFound) {
                    $view.find('.js-quantity').on('change', function () {
                        if (updateTimer) {
                            root.clearTimeout(updateTimer);
                            updateTimer = null;
                        }

                        updateTimer = root.setTimeout(_updatePriceTotals, 500);
                    });
                }
            },
            updatePriceTotals: function () {
                if (updateTimer) {
                    root.clearTimeout(updateTimer);
                    updateTimer = null;
                }

                var isAnyElementFound = $priceTotalsElements.length > 0;

                if (isAnyElementFound) {
                    _updatePriceTotals();
                }
            },
            getCurrentTotals() { return _currentTotals; }
        }
    }

    function packageComponentProcessor($view, model, utils) {
        var $packageComponentsContainer = utils.$getProductContainerElements($view, '.js-component-products-list');
        if (!model.packageComponentProducts || !$packageComponentsContainer.length) {
            return;
        }

        var $generalProdQty = utils.$getProductContainerElements($view, '.js-quantity');
        $generalProdQty.on('change', function () {
            var quantity = utils.tryParseNumberOrDefault($(this).val());
            _.each(model.packageComponentProducts, function (packageComponent) {
                var $componentProductContainer = $packageComponentsContainer.find('.js-component-product[data-uniqueid="' + packageComponent.uniqueId + '"]');
                $componentProductContainer.find('.js-component-quantity').text(packageComponent.initialQuantity.raw * quantity);
            });

        });
    }

    function groupingProductProcessor($view, model, utils, say, pubsub, priceTotals, variantProcessorsMap) {
        const ComponentBuyMode = { "SingleProduct": 0, "MultipleProducts": 1, "AllProducts": 2, "OneOrMoreProducts": 3 }
        const TemplateMarkup = { "GroupingProductDefault": 0, "GroupingProductV2": 1 };
        var $groupingProductContainer;
        var groupingProductMarkup;
        var isInitializing = true;
        var groupingProductTemplate;
        var docContentMap = {};

        function _getGroupingComponentProduct(componentUniqueId, productUniqueId) {
            const groupingProductComponent = _getGroupingComponent(componentUniqueId);
            const groupingComponentProduct = groupingProductComponent.componentProducts.find(x => x.uniqueId === productUniqueId);
            if (!groupingComponentProduct) {
                console.error(`Grouping product component product was not found by id = ${productUniqueId}`);
            }

            return groupingComponentProduct;
        }

        function _getGroupingComponent(componentUniqueId) {
            const groupingComponent = model.groupingComponents.find(x => x.uniqueId === componentUniqueId);
            if (!groupingComponent) {
                console.error(`Grouping component was not found by id = ${componentUniqueId}`);
            }
            return groupingComponent;
        }

        function _getGroupingComponentTemplate(groupingComponent, groupingProductId) {
            const componentTemplate = JSON.parse(JSON.stringify(groupingComponent))
            componentTemplate.componentProducts = groupingComponent.componentProducts.filter(x => x.groupingProductId == groupingProductId);
            componentTemplate.componentProducts.sort((x, y) => x.orderNo - y.orderNo);
            return componentTemplate;
        }

        function _toLocalFixed(number, fraction) {
            return number.toLocaleString(undefined, { minimumFractionDigits: fraction, maximumFractionDigits: fraction });
        }

        function _setPriceImpact($productPriceImpact, price) {
            $productPriceImpact.html(`${model.currencyCode} ${_toLocalFixed(price, 2)}`);
            if (price === 0) {
                $productPriceImpact.removeClass('increase');
                $productPriceImpact.removeClass('decrease');
                $productPriceImpact.addClass('noimpact');
            } else if (price > 0) {
                $productPriceImpact.addClass('increase');
                $productPriceImpact.removeClass('decrease');
                $productPriceImpact.removeClass('noimpact');
            } else {
                $productPriceImpact.removeClass('increase');
                $productPriceImpact.addClass('decrease');
                $productPriceImpact.removeClass('noimpact');
            }
        }

        function _setGroupingComponentStockInfo($componentContainer) {
            const componentUniqueId = $componentContainer.data('componentuniqueid');

            // stock info
            $componentContainer.find('[data-uniqueid]').each((i, groupingComponentProduct) => {
                const $productContainer = $(groupingComponentProduct);
                const productUniqueId = $productContainer.data('uniqueid');
                const componentProduct = _getGroupingComponentProduct(componentUniqueId, productUniqueId);

                const $stockInfoContainer = $productContainer.find('.js-stock-info');
                if ($stockInfoContainer) {
                    const $stockText = $stockInfoContainer.find('.js-stock-text')
                    if ($stockText) {
                        $stockText.text(componentProduct.stockText);
                        if (!$stockText.hasClass(componentProduct.stockCssClass)) {
                            $stockText.addClass(componentProduct.stockCssClass);
                        }
                    }
                }
            });
        }

        function _setGroupingComponentPrices(groupedTotals) {
            // prices are always expected to be found; just in case it's missing due to a bug - will update prices with empty values so it is visible
            const groupingComponentProductPrices = groupedTotals ? groupedTotals.find(x => x.groupingComponentProductPrices)?.groupingComponentProductPrices : null;

            $groupingProductContainer.find('[data-componentuniqueid]').each((i, groupingComponentContainer) => {
                const $componentContainer = $(groupingComponentContainer);
                const componentUniqueId = $componentContainer.data('componentuniqueid');
                const groupingProductComponent = _getGroupingComponent(componentUniqueId);

                let selectedPrice = 0;
                // first: find and set prices for selected product
                $componentContainer.find('[data-uniqueid]').each((i, groupingComponentProduct) => {
                    const $productContainer = $(groupingComponentProduct);
                    const isSelected = $productContainer.data('isselected');
                    if (!isSelected) {
                        return;
                    }

                    const productUniqueId = $productContainer.data('uniqueid');
                    const quantity = $productContainer.find('.js-quantity').val();
                    const componentProduct = _getGroupingComponentProduct(componentUniqueId, productUniqueId);
                    const sellPrice = groupingComponentProductPrices ? groupingComponentProductPrices[componentProduct.uniqueKey] : null;
                    let sellPriceFormatted = '';
                    if (sellPrice) {
                        sellPriceFormatted = sellPrice.formatted;
                        selectedPrice = sellPrice.raw * quantity;
                    }

                    $productContainer.find('.js-grouping-product-price').html(sellPriceFormatted);
                    _setPriceImpact($productContainer.find('.js-grouping-product-price-impact'), 0);
                });

                // second: set prices for not selected product
                $componentContainer.find('[data-uniqueid]').each((i, groupingComponentProduct) => {
                    const $productContainer = $(groupingComponentProduct);
                    const isSelected = $productContainer.data('isselected');
                    if (isSelected) {
                        return;
                    }

                    const productUniqueId = $productContainer.data('uniqueid');
                    const quantity = $productContainer.find('.js-quantity').val();
                    const componentProduct = _getGroupingComponentProduct(componentUniqueId, productUniqueId);
                    const sellPrice = groupingComponentProductPrices ? groupingComponentProductPrices[componentProduct.uniqueKey] : null;
                    let sellPriceFormatted = '', diffPrice = 0;
                    if (sellPrice) {
                        sellPriceFormatted = sellPrice.formatted;
                        const nonSelectedPrice = sellPrice.raw * quantity;
                        diffPrice = groupingProductComponent.buyMode === ComponentBuyMode.SingleProduct ? nonSelectedPrice - selectedPrice : nonSelectedPrice;
                    }

                    $productContainer.find('.js-grouping-product-price').html(sellPriceFormatted);
                    _setPriceImpact($productContainer.find('.js-grouping-product-price-impact'), diffPrice);
                });
            });
        }

        function _setAllComponentProductsNotSelected($componentContainer) {
            const groupingProductComponent = _getGroupingComponent($componentContainer.data('componentuniqueid'));
            if (groupingProductComponent.buyMode === ComponentBuyMode.SingleProduct) {
                const $productContainer = $componentContainer.find('[data-uniqueid]');
                $productContainer.data('isselected', false);
                $productContainer.removeClass('selected');
            }
        }

        function _toggleProductSelected($componentContainer, $productContainer, isSelected) {
            _setAllComponentProductsNotSelected($componentContainer);

            $productContainer.data('isselected', isSelected);
            if (isSelected) {
                $productContainer.addClass('selected');
                $productContainer.attr('data-isselected', isSelected);
            } else {
                $productContainer.removeClass('selected');
                $productContainer.attr('data-isselected', isSelected);
            }

            _setGroupingComponentStockInfo($componentContainer);
        }

        function _isComponentRequiredToBuy(buyMode) {
            return buyMode === ComponentBuyMode.SingleProduct || buyMode === ComponentBuyMode.AllProducts || buyMode === ComponentBuyMode.OneOrMoreProducts;
        }

        function _toggleQuantityValueInComponent($quantity){
            const $componentContainer = $quantity.closest('[data-componentuniqueid]');
            const componentUniqueId = $componentContainer.data('componentuniqueid');
            const groupingComponent = _getGroupingComponent(componentUniqueId);
            const minQuantity = $quantity.data('min-quantity');


            if (groupingProductMarkup === TemplateMarkup.GroupingProductV2){
                if (groupingComponent.buyMode === ComponentBuyMode.SingleProduct && $quantity.val() > 0) {
                    const $allExceptEditedInput = $componentContainer.find('.js-quantity').not($quantity);
                    $allExceptEditedInput.val(0);
                    $allExceptEditedInput.closest('.js-plus-minus-container-grouping-product').find('button[data-action="decrease"]').attr('disabled', 'disabled');
                }
                if (groupingComponent.buyMode === ComponentBuyMode.OneOrMoreProducts) {
                    var $positiveQuantityInputs = $componentContainer.find('.js-quantity').filter((i, element) => $(element).val() > 0);
                    if ($positiveQuantityInputs.length === 1 && $quantity.val() <= minQuantity) {
                        $positiveQuantityInputs.closest('.js-plus-minus-container-grouping-product').find('button[data-action="decrease"]').attr('disabled', 'disabled');
                    } else if ($positiveQuantityInputs.length > 1 ) {
                        $positiveQuantityInputs.closest('.js-plus-minus-container-grouping-product').find('button[data-action="decrease"]').removeAttr('disabled');
                    }
                }
            }
        }

        function _setupControlElements() {
            switch(groupingProductMarkup){
                case TemplateMarkup.GroupingProductDefault: //Going to be deprecated. Use v2 instead.
                    utils.initQuantityModifyButtons($groupingProductContainer, '.js-gp-quantity-modify-btn');
                    break;
                case TemplateMarkup.GroupingProductV2:
                    utils.initQuantityModifyButtons2($view, '.js-plus-minus-container-grouping-product');
                    break;
            }

            $groupingProductContainer.find('.js-select-product').each((i, element) => {
                $(element).on('change', function (evt) {
                    const $selectProductInput = $(this);
                    const $componentContainer = $selectProductInput.closest('[data-componentuniqueid]');
                    const $productContainer = utils.$getProductContainerFor($selectProductInput);
                    const isSelected = $selectProductInput.is(':checked');
                    const componentUniqueId = $componentContainer.data('componentuniqueid');
                    const groupingComponent = _getGroupingComponent(componentUniqueId);

                    // prevent uncheck if component is required and no more checked products
                    if (!isSelected && _isComponentRequiredToBuy(groupingComponent.buyMode) && !$componentContainer.find('input[name="' + this.name + '"]:checked').not(this).length) {
                        $(this).prop('checked', true);
                        return;
                    }

                    if (groupingComponent.buyMode === ComponentBuyMode.SingleProduct) {
                        const $allExceptCheckedComponentSelectors = $componentContainer.find('input[name="' + this.name + '"]').not(this);
                        $allExceptCheckedComponentSelectors.prop('checked', false);
                    }

					if (groupingProductMarkup === TemplateMarkup.GroupingProductDefault && groupingComponent.buyMode === ComponentBuyMode.OneOrMoreProducts){
                        if(isSelected) {
                            $componentContainer.find('input[name="' + this.name + '"]:checked').next('.js-grouping-product-link').find('.grouping-product-remove-btn').css('display', 'flex');
                            $selectProductInput.next('.js-grouping-product-link').find('.grouping-product-remove-btn').css('display', 'flex');
                        } else {
                            $componentContainer.find('input[name="' + this.name + '"]').next('.js-grouping-product-link').find('.grouping-product-remove-btn').css('display', 'none');
                        }
					}

                    _toggleProductSelected($componentContainer, $productContainer, isSelected);

                    priceTotals.updatePriceTotals();
                });
            });

            $('#root').on('click', function(event) {
                if (!$(event.target).closest($groupingProductContainer).length){
                    $('.js-grouping-product').removeClass('active');
                }
            });

            $('.js-grouping-product').on('click', function() {
                const $this = $(this),
                    groupingComponent = $this.closest('.grouping-component'),
                    imageItem = $this.find('.js-grouping-product-image'),
                    imageItemSelected = groupingComponent.find('.js-grouping-component-image-selected'),
                    imageLinkItemSelected = groupingComponent.find('.js-grouping-component-image-link-selected'),
                    productContainer = $this.closest('.js-grouping-product-container');

                    productContainer.find('.js-grouping-product').not($this).removeClass('active');
                    $this.addClass('active');

                    imageLinkItemSelected.attr({
                        'href': imageItem.data('src'),
                        'data-width': imageItem.data('width'),
                        'data-height': imageItem.data('height')
                    }).removeClass('grouping-component-img-link-opacity');

                    imageItemSelected.attr('src', imageItem.attr('src'));
            });

            $groupingProductContainer.find('.js-quantity').each((i, element) => {
                const $quantityInput = $(element);
                _toggleQuantityValueInComponent($quantityInput);
                $quantityInput.on('change', () => {
                    const minQuantity = $quantityInput.data('min-quantity');
                    if(minQuantity){
                        const quantityValue = $quantityInput.val();
                        const $selectProduct = $quantityInput.closest('.js-grouping-product').find('.js-select-product');
                        quantityValue < minQuantity ? $selectProduct.prop('checked', false) : $selectProduct.prop('checked', true);
                        _toggleQuantityValueInComponent($quantityInput);
                    }
                    if(groupingProductMarkup === TemplateMarkup.GroupingProductV2){
                        const $componentContainer = $quantityInput.closest('[data-componentuniqueid]');
                        const $productContainer = $quantityInput.closest('.js-grouping-product');
                        const isSelected = $productContainer.find('.js-select-product').is(':checked');
                        _toggleProductSelected($componentContainer, $productContainer, isSelected);
                    }
                    priceTotals.updatePriceTotals();
                });
            });

            $groupingProductContainer.find('.js-more-info').each((i, element) => {
                const $infoLink = $(element);
                $infoLink.on('click', (evt) => {
                    evt.preventDefault();
                    const $productContainer = utils.$getProductContainerFor($infoLink);
                    const $moreInfoCont = $productContainer.find('.js-more-info-cont');
                    const $moreInfoContTeaser = $productContainer.find('.js-more-info-cont-teaser');
                    const $moreInfoContContent = $productContainer.find('.js-more-info-cont-content');

                    if ($moreInfoCont.length) {
                        const $componentContainer = $infoLink.closest('[data-componentuniqueid]');
                        const componentUniqueId = $componentContainer.data('componentuniqueid');
                        const prodUniqueId = $productContainer.data('uniqueid');
                        const componentProduct = _getGroupingComponentProduct(componentUniqueId, prodUniqueId);

                        if (docContentMap.hasOwnProperty(componentProduct.itemId)) {
                            $moreInfoCont.collapse('toggle');
                        } else {
                            $.ajax({
                                url: root.R + 'api/document/getDocumentTeaserAndContent',
                                type: 'GET',
                                data: { itemId: componentProduct.itemId }
                            })
                                .done(function (result) {
                                    docContentMap[componentProduct.itemId] = result;
                                    $moreInfoContTeaser.html(result.teaser);
                                    $moreInfoContContent.html(result.content);
                                    $moreInfoCont.collapse('show');
                                })
                                .fail(function (errResp) {
                                    var errorMessage = utils.extractErrorMessageFromResponse(errResp);
                                    console.error('Failed to get document content', errorMessage);
                                });
                        }
                    }
                });
            });
        }

        function _setProductContainerValues($productContainer, groupingComponentProduct, selectedVariant) {
            $productContainer.find('.js-grouping-product-link').attr({
                'href': groupingComponentProduct.url,
                'title': groupingComponentProduct.title
            });
            $productContainer.find('.js-grouping-product-title').html(groupingComponentProduct.title);
            const $groupingProductImage = $productContainer.find('.js-grouping-product-image');

            if ($groupingProductImage) {
                if (groupingComponentProduct.mainImage) {
                    $groupingProductImage.attr('src', groupingComponentProduct.mainImage.previewUrl || '');
                    $groupingProductImage.attr('alt', groupingComponentProduct.mainImage.title || '');
                } else {
                    $groupingProductImage.attr('src', '');
                    $groupingProductImage.attr('alt', '');
                }
            }

            const $groupingProductVariantImage = $productContainer.find('.js-grouping-product-variant-image');
            if ($groupingProductVariantImage) {
                if (selectedVariant && selectedVariant.image) {
                    $groupingProductVariantImage.attr('src', selectedVariant.image.thumbnailUrl);
                    $groupingProductVariantImage.attr('alt', selectedVariant.name);
                } else {
                    $groupingProductVariantImage.attr('src', '');
                    $groupingProductVariantImage.attr('alt', '');
                }
            }

            const $quantity = $productContainer.find('.js-quantity');
            const currentQuantity = utils.tryParseNumberOrDefault($quantity.val(), 1);
            const $componentContainer = $quantity.closest('[data-componentuniqueid]');
            const componentUniqueId = $componentContainer.data('componentuniqueid');
            const groupingComponent = _getGroupingComponent(componentUniqueId);

            if (groupingComponentProduct.initialQuantity.raw > currentQuantity) {
                $quantity.val(groupingComponentProduct.initialQuantity.formatted);
                if (groupingProductMarkup === TemplateMarkup.GroupingProductV2 &&
                    groupingComponent.buyMode === ComponentBuyMode.MultipleProducts &&
                    groupingComponentProduct.initialQuantity.raw >= groupingComponentProduct.minQuantity.raw)
                {
                    $quantity.closest('.js-plus-minus-container-grouping-product').find('button[data-action="decrease"]').removeAttr('disabled');
                }
            }

            _toggleQuantityValueInComponent($quantity)

            $productContainer.data({
                'uniqueid': groupingComponentProduct.uniqueId,
                'uniquekey': groupingComponentProduct.uniqueKey,
                'productid': groupingComponentProduct.productId
            });
        }

        function _setVariantProductValues($productContainer, productId, groupingProductId, groupingProductIndex, selectedVariant) {
            const $componentContainer = $productContainer.closest('[data-componentuniqueid]');
            const componentUniqueId = $componentContainer.data('componentuniqueid');
            const groupingComponent = _getGroupingComponent(componentUniqueId);
            const componentTemplate = _getGroupingComponentTemplate(groupingComponent, groupingProductId)

            let componentProduct;
            if (productId) {
                componentProduct = componentTemplate.componentProducts.find(x => x.groupingProductId === groupingProductId && x.groupingProductIndex === groupingProductIndex && x.productId === productId);
                $productContainer.find('.js-select-product').prop('checked', true);
            } else {
                const productUniqueId = $productContainer.data('uniqueid');
                componentProduct = componentTemplate.componentProducts.find(x => x.uniqueId === productUniqueId);
                // find parent
                componentProduct = componentTemplate.componentProducts.find(x => x.groupingProductId === groupingProductId && x.groupingProductIndex === groupingProductIndex && x.productId === componentProduct.parentProductId);
            }

            if (componentProduct) {
                _setProductContainerValues($productContainer, componentProduct, selectedVariant);
                if (productId) {
                    _toggleProductSelected($componentContainer, $productContainer, true);
                }
            } else {
                console.error(`Component product not found by id = ${productId}`);
            }
        }

        function _setupVariants(groupingProductId) {
            $groupingProductContainer.find('[data-uniqueid]').each((i, productContainer) => {
                const $productContainer = $(productContainer);
                const componentUniqueId = $productContainer.closest('[data-componentuniqueid]').data('componentuniqueid');
                const productUniqueId = $productContainer.data('uniqueid');
                const groupingProductIndex = $productContainer.data('groupingproductindex');

                const componentTemplate = _getGroupingComponentTemplate(_getGroupingComponent(componentUniqueId), groupingProductId)
                const componentProduct = _getGroupingComponentProduct(componentUniqueId, productUniqueId);

                if (componentProduct.isMainProductOfProductWithVariants) {
                    $productContainer.on('variantsprocessor:beforeloadvariantproduct', (e, variantProduct, selectedVariant) => {
                        e.preventDefault();
                        e.stopPropagation();

                        _setVariantProductValues($productContainer, variantProduct ? variantProduct.productId : null, groupingProductId, groupingProductIndex, selectedVariant);

                        if (!isInitializing) {
                            priceTotals.updatePriceTotals();
                        }
                    });

                    const productVariantsProcessor = variantProcessorsMap[productUniqueId];
                    const preselectedVariantProduct = componentTemplate.componentProducts.find(x => x.parentProductId === componentProduct.productId && x.groupingProductIndex === componentProduct.groupingProductIndex && x.isPreSelected);
                    if (preselectedVariantProduct) {
                        productVariantsProcessor.selectVariantByProductId(preselectedVariantProduct.productId);
                    }
                }
            });
        }

        function _setupGroupingProductVariants() {
            $view.on('variantsprocessor:beforeloadvariantproduct', async function onbeforeloadvariantproduct(e, variantProduct) {
                const groupingProductId = !!variantProduct ? variantProduct.productId : model.groupingProductId;
                await _generateGroupingProduct(groupingProductId);
                _setup(groupingProductId);
            });
        }

        async function _generateGroupingProduct(groupingProductId, completeCallback) {

            $groupingProductContainer.empty();

            var promises = [];

            model.groupingComponents.sort((x, y) => x.orderNo - y.orderNo).forEach(groupingComponent => {
                const componentTemplate = _getGroupingComponentTemplate(groupingComponent, groupingProductId)

                const templateData = {
                    groupingComponent: componentTemplate,
                    BuyMode: { "SingleProduct": 0, "MultipleProducts": 1, "AllProducts": 2, "OneOrMoreProducts": 3 },
                    VariantViewType: { 0: "dropdownvariant", 1: "tilesvariant", 2: "relimgtilesvariant", 3: "fancyboxrelimgtilesvariant", 4: "dropdownvariant2", 5: "dropdownvariant4", 6: "relimgtilesvariant2-outlet", 7: "tilesvariant2-outlet", 8: "relimgtilesvariant3-outlet" },
                    ComponentViewType: { "Collapsed": 0, "Expanded": 1 },
                    settings: { showMoreInfoLink: model.showMoreInfoLinkForComponents },
                    metadata: model.metadata
                };
                const groupingComponentContainer = _.template(groupingProductTemplate, templateData);
                const $groupingComponentContainer = $(groupingComponentContainer);
                $groupingProductContainer.append($groupingComponentContainer);
                groupingProductMarkup = $groupingProductContainer.find('[data-componentuniqueid]').data('markup') ?? TemplateMarkup.GroupingProductDefault;

                const $collapseExpandComponent = $groupingComponentContainer.find('.js-collapse-expand');
                const $collapseExpandCont = $groupingComponentContainer.find('.js-collapse-expand-cont');

                $collapseExpandComponent.on('click', (evt) => {
                    evt.preventDefault();

                    if ($collapseExpandCont.length) {
                        $collapseExpandCont.collapse('toggle');
                    }
                });

                componentTemplate.componentProducts.forEach(groupingComponentProduct => {
                    if (groupingComponentProduct.groupingProductId === groupingProductId) {
                        if (groupingComponentProduct.isMainProductOfProductWithVariants) {
                            const $groupingComponentProductContainer = $groupingComponentContainer.find(`.js-grouping-product[data-uniqueid="${groupingComponentProduct.uniqueId}"]`);
                            groupingComponentProduct.variantRelImageMatchRegExp = model.variantRelImageMatchRegExp;
                            const options = {
                                $productContainer: $groupingComponentProductContainer,
                                productModel: groupingComponentProduct,
                                priceTotals: priceTotals,
                                metadata: model.metadata,
                                say: say,
                                pubsub: pubsub,
                                utils: utils,
                            };
                            promises.push(initVariantsProcessor(options, variantProcessorsMap));
                        }
                    }
                });
            });

            // Waiting untill all variant processors are initialized
            await Promise.all(promises);
        }

        function _setup(groupingProductId) {
            isInitializing = true;

            _setupControlElements();
            _setupVariants(groupingProductId);

            $groupingProductContainer.find('[data-componentuniqueid]').each((i, groupingComponentContainer) => {
                _setGroupingComponentStockInfo($(groupingComponentContainer))
            });

            isInitializing = false;
        }

        return {
            init: async function () {
                $groupingProductContainer = utils.$getProductContainerElements($view, '.js-grouping-product-container');
                if (!$groupingProductContainer) {
                    console.error('Grouping product container was not found.')
                    return;
                }

                var $groupingProductTemplateContainer = $('#uc209-grouping-product-template');
                if ($groupingProductTemplateContainer.length == 0 || !$groupingProductTemplateContainer[0].innerText) {
                    console.error('Product is configured as package product but the package product template is not found.')
                    new notificator(pubsub, utils).error('Produktet er konfigurert som pakkeprodukt, men pakkeproduktmalen ble ikke funnet.');
                    return;
                }

                let groupingProductId = model.groupingProductId;

                const mainProductUniqueId = $view.data('uniqueid');
                const mainProductVariantsProcessor = variantProcessorsMap[mainProductUniqueId];
                if (mainProductVariantsProcessor) {
                    const selectedVariantProduct = mainProductVariantsProcessor.getSelectedVariantProduct();
                    if (selectedVariantProduct && selectedVariantProduct.productId) {
                        groupingProductId = selectedVariantProduct.productId;
                    }
                }

                groupingProductTemplate = $groupingProductTemplateContainer[0].innerText;

                _setupGroupingProductVariants();

                await _generateGroupingProduct(groupingProductId);

                _setup(groupingProductId);

                $view.on('priceTotalsProcessor:ontotalsupdated', (_, groupedTotals) => _setGroupingComponentPrices(groupedTotals));
            },
        }
    }

    function util() {
        function _$getProductContainerFor(elem) {
            // It is the requirement that every product container should have data-uniqueid attirbute
            return $(elem).closest('[data-uniqueid]');
        }
        function _tryParseNumberOrDefault(rawValue, defaultValue) {
            var parsed;

            if (typeof rawValue === 'string') {
                parsed = parseFloat(rawValue.replace(',', '.'));
            } else {
                parsed = rawValue;
            }

            return parsed === 0 ? parsed : parsed || defaultValue || 0;
        }

        return {
            tryParseNumberOrDefault: _tryParseNumberOrDefault,
            $getProductContainerFor: _$getProductContainerFor,
            $getProductContainerElements: function ($container, selector) {
                // There might be situations when there are multiple product containers with the similar elements from differen products inside another product container.
                // An example: additional products that are rendered inside the general product's container.
                // In addition, there can be situations when the same product is rendered multiple times as additional or both as additional and as general product.
                // So, if we will try to find elements by selector, e.g. $view.find('.js-variant-selector') then jQuery will find variant selectors of the current product container and also all variant selectors of all nested product containers.
                // Therefore, we need to know for sure what elements belong to the current product container.
                // We can rely on the closest container with the data-uniqueid attribute (since it is a requirement to have it) and then compare the found element with the container from arguments.
                return $container.find(selector).filter(function () { return _$getProductContainerFor(this).is($container); });
            },
            trimAndLowerCase: function (str) {
                return (str || '').trim().toLowerCase();
            },
            caseInsensetiveEquals: function (str1, str2) {
                return typeof str1 === 'string' && typeof str2 === 'string'
                    ? str1.trim().toLowerCase() === str2.trim().toLowerCase()
                    : str1 === str2;
            },
            extractErrorMessageFromResponse: function (errorResponse) {
                var message;
                if (typeof errorResponse === 'object' && errorResponse !== null) {
                    // Extract error message
                    try {
                        var parsedResponseBody = JSON.parse(errorResponse.responseText);
                        message = parsedResponseBody.ExceptionMessage ? parsedResponseBody.ExceptionMessage : (parsedResponseBody.Message ? parsedResponseBody.Message : errorResponse.statusText);
                    } catch (e) {
                        message = errorResponse.statusText;
                    }
                } else {
                    message = errorResponse;
                }

                return message;
            },
            initQuantityModifyButtons2: function ($container, selector) {
                $container.find(selector).each(function(i, element){
                    let $this = {
                        "quantity": $(element).find('input'),
                        "button": $(element).find('button'),
                        "label": $(element).find('label'),
                        "labelQuantityText": $(element).find('.js-quantity-text')
                    }
                    const _allowMinBreak = $(element).data('allow-min-break');
                    const _stepAttr = _tryParseNumberOrDefault($this.quantity.attr('step'), 1);
                    const _minAttrAllowedQuantity = _tryParseNumberOrDefault($this.quantity.attr('min'), 0);
                    const _minDataAttrAllowedQuantity = _tryParseNumberOrDefault($this.quantity.data('min-quantity'), 0); //Has higher priority over minAllowedQuantity
                    const _minAllowedQuantity = Math.max(_minAttrAllowedQuantity, _minDataAttrAllowedQuantity);

                    let _quantity = _tryParseNumberOrDefault($this.quantity.val());

                    $this.quantity.on('change', function () {
                        const userTypedQuantity = _tryParseNumberOrDefault($this.quantity.val());

                        if (_allowMinBreak === true) {
                            _quantity = userTypedQuantity < _minAllowedQuantity ? 0 : userTypedQuantity;
                            _quantity == 0 || _quantity < _minAllowedQuantity ? _disableDecreaseButton() : _enableDecreaseButton();
                        } else{
                            _quantity = Math.max(_minAllowedQuantity, userTypedQuantity);
                            _quantity <= _minAllowedQuantity ? _disableDecreaseButton() : _enableDecreaseButton();
                        }

                        _updateView(_quantity, true);
                    });

                    $this.button.on('click', function () {
                        const newQuantityValue = _tryParseNumberOrDefault($this.quantity.val()); //Protects in case it was set progrematically by other cotnrols
                        switch ($(this).data('action')) {
                            case 'decrease':
                                if(_validateDecreaseAction(newQuantityValue)){
                                    _quantity = _getDecreasedQuantity(_quantity);
                                    _updateView(_quantity, true);
                                    _triggerQuantityInput();
                                }
                                break;
                            case 'increase':
                                _quantity = _getIncreasedQuantity(newQuantityValue);
                                _updateView(_quantity, true);
                                _triggerQuantityInput();
                                break;
                        }
                    });

                    const _triggerQuantityInput = () => {
                        $this.quantity.trigger('change');
                        $this.quantity.trigger('focusout'); // focusout triggers min/max validation check
                    }

                    const _enableDecreaseButton = () => {
                        $($this.button[0]).removeAttr('disabled');
                    };

                    const _disableDecreaseButton = () => {
                        $($this.button[0]).attr('disabled', 'disabled');
                    };

                    const _updateView = (value, formatValueFlag) => {
                        const quantityFormated = formatValueFlag ? _formatQuantity(value) : value;
                        $this.labelQuantityText.text(quantityFormated);
                        $this.quantity.val(quantityFormated);
                        _quantity = value;
                    };

                    const _formatQuantity = (value) => {
                        const quantityHasDot = $this.quantity.val().indexOf('.') > 0;
                        return quantityHasDot ? value.toFixed(1) : value.toFixed(0)
                    }

                    const _validateDecreaseAction = (quantity) => {
                        return _getDecreasedQuantity(quantity) >= (_allowMinBreak === true ? 0 : _minAllowedQuantity);
                    }

                    const _getDecreasedQuantity = (quantity) => {
                        return _allowMinBreak === true
                            ? quantity - _stepAttr < _minAllowedQuantity ? 0 : quantity - _stepAttr
                            : quantity - _stepAttr <= _minAllowedQuantity ? _minAllowedQuantity : quantity - _stepAttr;
                    };

                    const _getIncreasedQuantity = (quantity) => {
                        return quantity + _stepAttr < _minAllowedQuantity ? _minAllowedQuantity : quantity + _stepAttr;
                    };
                })
            },
            initQuantityModifyButtons: function ($container, selector) {
                $container.find(selector).on('click', function () {
                    const $this = $(this);
                    const dataAttributes = {
                        actionType: $this.data('action'),
                        quantityTxbId: $this.data('target'),
                    };

                    const $quantityInput = $('#' + dataAttributes.quantityTxbId);
                    const quantityMin = $quantityInput.attr('min') || 0;
                    const quantityMax = $quantityInput.attr('max');
                    let quantity = _tryParseNumberOrDefault($quantityInput.val());

                    switch (dataAttributes.actionType) {
                        case 'decrease':
                            quantity = --quantity;
                            if (quantity <= quantityMin) {
                                quantity = quantityMin;
                                $this.attr('disabled', 'disabled');
                            } else {
                                $this.parent().find('[data-action="increase"]').removeAttr('disabled');
                            }
                            break;
                        case 'increase':
                            quantity = ++quantity;
                            if (quantityMax && quantity >= quantityMax) {
                                quantity = quantityMax;
                                $this.attr('disabled', 'disabled');
                            } else {
                                $this.parent().find('[data-action="decrease"]').removeAttr('disabled');
                            }
                            break;
                    }

                    if (quantity < 0) {
                        $quantityInput.val(0);
                    } else {
                        quantity = Math.round(quantity * 10) / 10;
                        $quantityInput.val(quantity);
                    }
                    $quantityInput.trigger('change');
                    $quantityInput.trigger('focusout'); // focusout triggers min/max validation check
                });
            }
        }
    }
})(jQuery, _, window);